// import { withStyles, makeStyles } from '@mui/styles';
import React, { Component, useRef } from "react";
import Loader from "../../../../component/loader";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import {
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tabs,
  Tab,
  IconButton,
  FormHelperText,
  TextField,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ButtonGroup,
  FormControl,
  InputLabel,
  Select,
  Divider,
  MenuItem,
  Box,
  Checkbox,
  DialogContentText,
} from "@mui/material";
import Input from "../../../../component/inputpm";
import Button from "../../../../component/button";
import Autocomplete from "@mui/material/Autocomplete";
import Pagination from "@mui/material/Pagination";
import Tooltip from "@mui/material/Tooltip";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
  EditIconNew,
  ViewIconNew,
  OpenItemIcon,
  EndItemIcon,
  DeleteIconNew,
  AddItemIcon,
  DetailView,
  ListView,
  ExpandAll,
  AdvanceSearchIcon,
} from "../../../../component/icons/icons";
import CloseIcon from "@mui/icons-material/Close";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import debounce from "lodash.debounce";
import classes from "../../component/component.module.css";
import "../../component/specification/productSpecification.css";
import ProductSpecificationsListView from "../../component/specification/productSpecificationsListView.js";
import CustomDropdown from "../../component/specification/customEnumDropdown.js";
// import Files from 'react-files';
import CircularProgress from "@mui/material/CircularProgress";
import { Alert } from "@mui/material";
import {
  toApi,
  fromApi,
  normalizeDateTime,
} from "../../component/specification/characteristicMapper";
import FileUploader from "./specFileUploader.js";
import { withNavigation } from "../../../../helper/withNavigation.js";
import { formatNumber } from "../../../../helper/numberFormatter";

class ProductSpecification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      showLoading: false,
      showLoadingAddChar: false,
      showSpecLoading: false,
      searchCategory: "-",
      tabIndex: 0,
      productSpecifications: [],
      childData: {},
      expandedNodes: [],
      allExpanded: false,
      rowsPerPage: 20,
      page: 1,
      startRecord: 1,
      totalCount: 0,
      specificationSearchString: "",
      specificationSearchCategory: "PSC_PROD",
      addChildSpecCategory: "PSC_PROD",
      selectedSpecificationId: "",
      selectedSpecificationDescription: "",
      dialogOpenSpecification: false,
      formDataSpecification: {
        id: "",
        description: "",
        name: "",
        productSpecCode: "",
        parentId: "",
        visibility: "",
        category: { id: "", name: "" },
        productCategory: { id: "", name: "" },
        isMandatory: false,
      },
      createDataSpecification: {
        description: "",
        name: "",
        visibility: "",
        category: { id: "", name: "" },
        productCategory: { id: "", name: "" },
        isMandatory: false,
      },
      allProductSpecifications: [],
      parentSpecId: "",
      productCharacteristics: [],
      rowsPerPageCharacteristics: 20,
      pageCharacteristics: 1,
      startRecordCharacteristics: 1,
      totalCharacteristicsCount: 0,
      characteristicId: "",
      characteristicDescription: "",
      productCharacteristicsTypes: [],
      showSpecEditForm: false,

      dialogOpenAddCharacteristics: false,
      selectedCharacteristics: [],

      allProductCharacteristics: [],
      rowsPerPageAllCharacteristics: 20,
      pageAllCharacteristics: 1,
      startRecordAllCharacteristics: 1,
      totalAllCharacteristicsCount: 0,
      addCharacteristicName: "",
      addCharacteristicDescription: "",

      dialogOpenAddChildSpecification: false,
      rowsPerPageAllSpec: 20,
      pageAllSpec: 1,
      startRecordAllSpec: 1,
      totalAllSpecificationCount: 0,
      selectedChildSpecifications: [],

      specificationFormErrors: {
        name: false,
        description: false,
        productSpecCode: false,
      },
      excludeId: "",
      showSpecificationList: false,
      allSpecifications: [],
      allSpecificationCount: 0,

      pathForAddSpec: [],
      productSpecCode: "",
      //edit characteristics
      charCategoryList: [],
      specCategoryList: [],
      specProductCategoryList: [],

      dialogOpenCharacteristics: false,
      actionType: "view",
      formDataCharacteristics: {
        id: "",
        name: "",
        description: "",
        valueType: "", //productFeatureTypeId
        value: "",
        enumerationValues: [],
        tag: "",
        format: "",
        externalId: "",
        sequenceNum: "",
        category: { id: "", name: "" },
        relationshipType: "",
        charRelations: [],
      },
      characteristicsFormErrors: {
        name: false,
        description: false,
        valueType: false, //productFeatureTypeId
        specId: false, //productFeatureCategoryId
        value: false,
        sequenceNum: false,
      },
      selectedCharacteristicsByType: {},
      selectedProductSpecCode: "",
      relationshipType: "",
      productCharacteristicsForSameAsRelationship: [],
      childSpecifications: [],
      dialogOpenChildSpec: false,
      childSpecActionType: "view",
      formDataChildSpec: {
        description: "",
        name: "",
        visibility: "",
        category: { id: "", name: "" },
        productCategory: { id: "", name: "" },
        isMandatory: false,
      },
      showDeleteChildSpecConfirmDialog: false,
      deleteChildSpecId: "",
      responseMessage: "",
      responseSeverity: "info",
      rowCharOverrides: {},
      overrideOptions: [
        { id: "ViewOnly", name: "View only" },
        { id: "NoEditAfterPublish", name: "Immutable after first publish" },
        { id: "EditAfterPublish", name: "Mutable after first publish" },
        //{ id: "limit_values_spec_level", name: "Limit char values at Spec level from available list" } // already done via format field
      ],
    };
  }
  componentDidMount() {
    this.getCategoryList("PRODUCT_SPEC_CAT");
    this.getCategoryList("PRODUCT_CHAR_CAT");
    this.getSpecificationList();
    this.getCharacteristicTypeList();
    this.getProductCategoryList();
  }

  showResponseMessage = (message, severity = "info") => {
    //setResponseMessage(message);
    //setResponseSeverity(severity);
    this.setState({ responseMessage: message, responseSeverity: severity });
  };

  handleCloseSnackbar = () => {
    //setResponseMessage('');
    this.setState({ responseMessage: "" });
  };

  findSpecByPath = (nodes, targetPath, currentPath = []) => {
    for (let node of nodes) {
      const newPath = [...currentPath, node.id.toString()];
      const newPathString = newPath.join("-"); // Convert path to match stored format
      if (newPathString === targetPath) {
        return node; // Found the exact match
      }

      if (
        node.productSpecificationRelationship &&
        node.productSpecificationRelationship.length > 0
      ) {
        const found = this.findSpecByPath(
          node.productSpecificationRelationship,
          targetPath,
          newPath,
        );
        if (found) return found;
      }
    }
    return null; // Not found
  };

  getCategoryList = (type) => {
    this.setState({ showLoading: true });
    const formData = { type: type };
    const prioritizedItemId = "PSC_PROD";
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_PROD_SPEC_CHAR_CAT/endpoint`,
      formData,
    )
      .then((res) => {
        if (res.data?.categories) {
          if (type == "PRODUCT_SPEC_CAT") {
            const sortedCategoryList = [
              ...res.data.categories.filter(
                (item) => item.id === prioritizedItemId,
              ),
              ...res.data.categories
                .filter((item) => item.id !== prioritizedItemId)
                .sort((a, b) => a.name.localeCompare(b.name)),
            ];
            this.setState({ specCategoryList: sortedCategoryList });
          }
          if (type == "PRODUCT_CHAR_CAT") {
            const sortedCharCategoryList = [
              ...res.data.categories.sort((a, b) =>
                a.name.localeCompare(b.name),
              ),
            ];
            this.setState({ charCategoryList: sortedCharCategoryList });
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Spec/char Category:", err);
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
    this.setState({ showLoading: false });
  };

  getSpecificationList = () => {
    this.setState({ showLoading: true, showSpecLoading: true });

    const previousSelectedPath = this.state.selectedSpecificationPath; // Store previous selection
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productSpecifications?sortBy=name&sortOrder=ASC${this.state.specificationSearchString ? "&name=" + this.state.specificationSearchString : ""}` +
        `${this.state.specificationSearchCategory && this.state.specificationSearchCategory !== "-" ? "&category=" + this.state.specificationSearchCategory : ""}` +
        `${this.state.searchSpecProductCategory && this.state.searchSpecProductCategory !== "-" ? "&productCategory=" + this.state.searchSpecProductCategory : ""}` +
        `${this.state.searchProductSpecCode ? "&productSpecCode=" + this.state.searchProductSpecCode : ""}` +
        `${this.state.searchVisibility && this.state.searchVisibility !== "-" ? "&visibility=" + this.state.searchVisibility : ""}` +
        `${this.state.searchIsMandatory && this.state.searchIsMandatory !== "-" ? "&isMandatory=" + this.state.searchIsMandatory : ""}`,
      "",
      pageOptions,
    )
      .then((res) => {
        if (res.data.length > 0) {
          const matchedSpec = this.findSpecByPath(
            res.data,
            previousSelectedPath,
          );

          const selectedSpec = matchedSpec || res.data[0]; // Use previous or fallback to first item

          // Generate full path for selected spec
          const generatePath = (nodes, targetId, currentPath = []) => {
            for (let node of nodes) {
              const newPath = [...currentPath, node.id.toString()];
              if (node.id.toString() === targetId) return newPath.join("-");
              if (
                node.productSpecificationRelationship &&
                node.productSpecificationRelationship.length > 0
              ) {
                const foundPath = generatePath(
                  node.productSpecificationRelationship,
                  targetId,
                  newPath,
                );
                if (foundPath) return foundPath;
              }
            }
            return null;
          };
          const newSelectedPath =
            generatePath(res.data, selectedSpec.id.toString()) ||
            selectedSpec.id.toString();
          //console.log("--------newSelectedPath---",newSelectedPath);

          this.setState(
            {
              productSpecifications: res.data,
              totalCount: +res.headers["x-total-count"],
              selectedSpecificationId: selectedSpec.id,
              selectedProductSpecCode: selectedSpec.productSpecCode,
              selectedSpecificationName:
                selectedSpec.name || selectedSpec.description,
              selectedSpecificationDescription:
                selectedSpec.description || selectedSpec.name,
              selectedSpecificationVisibility: selectedSpec.visibility,
              selectedSpecificationIsMandatory: selectedSpec.isMandatory,
              selectedSpecificationCategory: selectedSpec.category,
              selectedSpecificationProductCategory:
                selectedSpec.productCategory,
              selectedSpecificationPath: newSelectedPath, // Ensure correct path for highlighting
              childSpecifications:
                selectedSpec.productSpecificationRelationship,
              showLoading: false,
              showSpecLoading: false,
            },
            () => {
              //this.getCharacteristicListBySpecId();
              this.getCharacteristicList();
            },
          );
        } else {
          this.setState({
            productSpecifications: [],
            totalCount: 0,
            productSpecCode: "",
            selectedSpecificationId: "",
            selectedSpecificationName: "",
            selectedSpecificationDescription: "",
            selectedSpecificationVisibility: "",
            selectedSpecificationIsMandatory: false,
            selectedSpecificationCategory: { id: "", name: "" },
            selectedSpecificationPath: "",
            showLoading: false,
            showSpecLoading: false,
            productCharacteristics: [],
            totalCharacteristicsCount: 0,
            childSpecifications: [],
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false, showSpecLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  getCharacteristicListBySpecId = () => {
    this.setState({ showLoading: true });
    let pageOptions = {
      batchSize: this.state.rowsPerPageCharacteristics,
      startRecord: this.state.startRecordCharacteristics,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productSpecifications/` +
        this.state.selectedSpecificationId,
      "",
      pageOptions,
    )
      .then((res) => {
        this.setState({ showLoading: false });
        if (res.data.characteristics.length > 0) {
          const transformed = res.data.characteristics.map(fromApi);
          this.setState({
            productCharacteristics: transformed,
            totalCharacteristicsCount: +res.headers["x-total-count"],
          });
        } else {
          this.setState({
            productCharacteristics: [],
            totalCharacteristicsCount: 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  getAllSpecificationList = () => {
    this.setState({ showLoading: true });
    console.log("----------getAllSpecificationList---");
    let pageOptions = {
      batchSize: this.state.rowsPerPageAllSpec,
      startRecord: this.state.startRecordAllSpec,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productSpecifications?sortBy=name&sortOrder=ASC${this.state.addChildSpecName ? "&name=" + this.state.addChildSpecName : ""}${this.state.addChildSpecDescription ? "&description=" + this.state.addChildSpecDescription : ""}${this.state.addChildSpecCategory && this.state.addChildSpecCategory !== "-" ? "&category=" + this.state.addChildSpecCategory : ""}${this.state.excludeId ? "&excludeId=" + this.state.excludeId : ""}`,
      "",
      pageOptions,
    )
      .then((res) => {
        this.setState({ showLoading: false });
        if (res.data.length > 0) {
          this.setState({
            allProductSpecifications: res.data,
            totalAllSpecificationCount: +res.headers["x-total-count"],
          });
        } else {
          this.setState({
            allProductSpecifications: [],
            totalAllSpecificationCount: 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  getCharacteristicList = () => {
    this.setState({ showLoading: true });
    let pageOptions = {
      batchSize: this.state.rowsPerPageCharacteristics,
      startRecord: this.state.startRecordCharacteristics,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productCharacteristics?sortBy=name&sortOrder=ASC${this.state.name ? "&name=" + encodeURIComponent(this.state.name) : ""}${this.state.characteristicDescription ? "&description=" + encodeURIComponent(this.state.characteristicDescription) : ""}${this.state.selectedSpecificationId ? "&specId=" + this.state.selectedSpecificationId : ""}`,
      "",
      pageOptions,
    )
      .then((res) => {
        if (res.data.length > 0) {
          const transformed = res.data.map(fromApi);
          this.setState({
            productCharacteristics: transformed,
            totalCharacteristicsCount: +res.headers["x-total-count"],
          });
          this.getCharacteristicListForSameAsRelationship();
        } else {
          this.setState({
            productCharacteristics: [],
            totalCharacteristicsCount: 0,
          });
        }
        this.setState({ showLoading: false });
      })
      .catch((err) => {
        console.error("Error fetching Product Characteristics:", err);
        this.setState({ showLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  refetchCharacteristicListForSameAsRelationship = debounce((inputValue) => {
    if (inputValue.length >= 3) {
      this.getCharacteristicListForSameAsRelationship(inputValue);
    }
  }, 400);

  getCharacteristicListForSameAsRelationship = (name) => {
    const previousSelectedPath = this.state.selectedSpecificationPath;
    let rootId = this.state.selectedSpecificationId;
    if (previousSelectedPath !== undefined) {
      const ids = previousSelectedPath.split("-");
      rootId = ids[0];
    }

    if (name !== undefined) {
      this.setState({ showLoadingProgress: true });
    } else {
      this.setState({ showLoading: true });
    }
    let pageOptions = {
      batchSize: 20,
      startRecord: 1,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productCharacteristics?sortBy=name&sortOrder=ASC&includeChild=true${name != undefined ? "&name=" + encodeURIComponent(name) : ""}&specId=${rootId}`,
      "",
      pageOptions,
    )
      .then((res) => {
        if (res.data.length > 0) {
          this.setState({
            productCharacteristicsForSameAsRelationship: res.data,
          });
        } else {
          this.setState({
            productCharacteristicsForSameAsRelationship: [],
          });
        }
        if (name !== undefined) {
          this.setState({ showLoadingProgress: false });
        } else {
          this.setState({ showLoading: false });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Characteristics:", err);
        if (name !== undefined) {
          this.setState({ showLoadingProgress: false });
        } else {
          this.setState({ showLoading: false });
        }
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  getAllCharacteristicList = () => {
    this.setState({ showLoadingAddChar: true });
    let pageOptions = {
      batchSize: this.state.rowsPerPageAllCharacteristics,
      startRecord: this.state.startRecordAllCharacteristics,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productCharacteristics?sortBy=name&sortOrder=ASC${this.state.addCharacteristicName ? "&name=" + encodeURIComponent(this.state.addCharacteristicName) : ""}${this.state.addCharacteristicDescription ? "&description=" + encodeURIComponent(this.state.addCharacteristicDescription) : ""}${this.state.searchCategory && this.state.searchCategory != "-" ? "&category=" + this.state.searchCategory : ""}`,
      "",
      pageOptions,
    )
      .then((res) => {
        if (res.data.length > 0) {
          const transformed = res.data.map(fromApi);
          this.setState({
            allProductCharacteristics: transformed,
            totalAllCharacteristicsCount: +res.headers["x-total-count"],
          });
        } else {
          this.setState({
            allProductCharacteristics: [],
            totalAllCharacteristicsCount: 0,
          });
        }
        this.setState({ showLoadingAddChar: false });
      })
      .catch((err) => {
        console.error("Error fetching Product Characteristics:", err);
        this.setState({ showLoadingAddChar: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  handleTabChange = (event, newValue) => {
    //console.log('=========newValue===',newValue)
    this.setState({ tabIndex: newValue });
  };

  onCharacteristicSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getCharacteristicList();
    }
  };

  onChangeSearchCategory = (e) => {
    let fieldName = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        this.getAllCharacteristicList();
      },
    );
  };

  onAllCharacteristicSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getAllCharacteristicList();
    }
  };

  handleNodeClick = (node, path) => {
    const pathString = path.join("-"); // Convert path array to string
    this.setState(
      {
        showSpecEditForm: false,
        selectedProductSpecCode: node.productSpecCode,
        selectedSpecificationId: node.id,
        selectedSpecificationDescription: node.description,
        selectedSpecificationName: node.name,
        selectedSpecificationVisibility: node.visibility,
        selectedSpecificationIsMandatory: node.isMandatory,
        selectedSpecificationCategory: node.category,
        selectedSpecificationProductCategory: node.productCategory,
        selectedSpecificationPath: pathString, // Store path for highlighting
        childSpecifications: node.productSpecificationRelationship || [],
      },
      () => {
        this.getCharacteristicList(node.id);
      },
    );
  };

  handleExpand = (node, path) => {
    const pathString = path.join("-"); // Convert array to a string

    //this.handleNodeClick(node, path);

    this.setState((prevState) => ({
      expandedNodes: prevState.expandedNodes.includes(pathString)
        ? prevState.expandedNodes.filter((p) => p !== pathString)
        : [...prevState.expandedNodes, pathString],
    }));
  };

  handleExpandUpdate = (node) => {
    const pathString = this.state.selectedSpecificationPath;
    //console.log("--------selectedPath--------------",pathString);
    this.getSpecificationList();
    /*this.setState((prevState) => ({
            expandedNodes: prevState.expandedNodes.includes(pathString)
                ? prevState.expandedNodes.filter(p => p !== pathString)
                : [...prevState.expandedNodes, pathString]
        }));*/
    if (!this.state.expandedNodes.includes(pathString)) {
      this.setState((prevState) => ({
        expandedNodes: [...prevState.expandedNodes, pathString],
      }));
    }
  };

  updateNodeChildSpecs = (nodes, targetId, newChildren) => {
    return nodes.map((node) => {
      if (node.id === targetId) {
        return { ...node, productSpecificationRelationship: newChildren }; // replace children
      } else if (node.productSpecificationRelationship) {
        return {
          ...node,
          productSpecificationRelationship: this.updateNodeChildSpecs(
            node.productSpecificationRelationship,
            targetId,
            newChildren,
          ),
        };
      }
      return node;
    });
  };

  getSpecificSpecificationDetail = (parentSpecIdForChild) => {
    this.setState({ showLoading: true });
    const currentPath = this.state.selectedSpecificationPath
      ? this.state.selectedSpecificationPath.split("-")
      : [];

    const pathString = currentPath.join("-");

    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productSpecifications/${parentSpecIdForChild}`,
      "",
    )
      .then((res) => {
        if (res.data) {
          if (res.data.productSpecificationRelationship) {
            const updatedTree = this.updateNodeChildSpecs(
              this.state.productSpecifications,
              parentSpecIdForChild,
              res.data.productSpecificationRelationship,
            );

            this.setState((prevState) => ({
              productSpecifications: updatedTree,
              expandedNodes: prevState.expandedNodes.includes(pathString)
                ? prevState.expandedNodes
                : [...prevState.expandedNodes, pathString],
              selectedSpecificationPath: pathString,
              showLoading: false,
            }));
          }
          this.setState({
            selectedSpecificationName: res.data.name,
            selectedSpecificationDescription: res.data.description,
            selectedSpecificationVisibility: res.data.visibility,
            selectedSpecificationIsMandatory: res.data.isMandatory,
            selectedSpecificationCategory: res.data.category,
            selectedSpecificationProductCategory: res.data.productCategory,
            selectedProductSpecCode: res.data.productSpecCode,
            childSpecifications: res.data.productSpecificationRelationship,
          });
        } else {
          this.setState({ showLoading: false });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false });
        const errMsg =
          err?.response?.data?.message || this.props.t("DEFAULT_ERROR_MESSAGE");
        this.props.setErrorMessage(errMsg, false);
      });
  };

  fetchChildSpecifications = (parentFeatureCategoryId) => {
    this.setState({ showLoading: true });
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productSpecification/${parentFeatureCategoryId}?sortBy=name&sortOrder=ASC`,
      "",
    )
      .then((res) => {
        this.setState(
          (prevState) => ({
            childData: {
              ...prevState.childData,
              [parentFeatureCategoryId]: res.data,
            },
          }),
          () => {
            this.setState((prevState) => ({
              expandedNodes: [
                ...prevState.expandedNodes,
                parentFeatureCategoryId,
              ],
            }));
          },
        );

        this.setState({ showLoading: false });
      })
      .catch((err) => {
        console.error("Error fetching Child Product Specifications:", err);
        this.setState({ showLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };
  renderTreeItems = (nodes, path = []) => {
    return nodes.map((node) => {
      const currentPath = [...path, node.id];
      const pathString = currentPath.join("-"); // Convert path to string
      const isSelected = this.state.selectedSpecificationPath === pathString;

      return (
        <TreeItem
          key={pathString} // Ensure unique key as a string
          nodeId={pathString} // Ensure nodeId is a string
          className={isSelected ? "selectedNode" : ""} // Apply class
          label={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {node.productSpecificationRelationship &&
                node.productSpecificationRelationship.length > 0 ? (
                  <>
                    <div
                      style={{ paddingRight: "5px" }}
                      className={`expandIconWrapper ${this.state.expandedNodes.includes(pathString) ? "isOpen" : ""}`}
                      onClick={() => this.handleExpand(node, currentPath)}
                    >
                      <OpenItemIcon />
                    </div>
                    <div
                      onClick={() => this.handleNodeClick(node, currentPath)}
                    >
                      {node.name || node.description}
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      style={{ paddingRight: "5px" }}
                      className={`expandIconWrapper`}
                    >
                      <EndItemIcon />
                    </div>
                    <div
                      onClick={() => this.handleNodeClick(node, currentPath)}
                    >
                      {node.name || node.description}
                    </div>
                  </>
                )}
              </div>
              <div>
                <Tooltip title="Add Child Specification">
                  <span style={{ float: "right" }}>
                    <AddItemIcon
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleOpenDialogAddChildSpecification(
                          node,
                          currentPath,
                        );
                      }}
                    />
                  </span>
                </Tooltip>
              </div>
            </div>
          }
        >
          {node.productSpecificationRelationship &&
            node.productSpecificationRelationship.length > 0 &&
            this.renderTreeItems(
              node.productSpecificationRelationship,
              currentPath,
            )}
        </TreeItem>
      );
    });
  };

  goToProduct = () => {
    this.props.router.navigate("/products");
  };

  handleOpenSpecificationSection = (row) => {
    this.setState({
      formDataSpecification: {
        id: row.id,
        productSpecCode: row.productSpecCode,
        description: row.description,
        name: row.name,
        visibility: row.visibility,
        isMandatory: row.isMandatory,
        category: row.category,
        productCategory: row.productCategory,
      },
    });
  };

  handleOpenDialogAddChildSpecification = (node, pathForAddSpec) => {
    this.setState(
      (prevState) => ({
        dialogOpenAddChildSpecification: true,
        parentSpecIdForChild: node.id,
        parentSpecNameForChild: node.name,
        parentSpecVisibilityForChild: node.visibility,
        parentSpecIsMandatoryForChild: node.isMandatory,
        parentSpecCategoryForChild: node.category?.id,
        parentSpecProductCategoryForChild: node.productCategory?.id,
        parentSpecDescriptionForChild: node.description,
        selectedChildSpecifications: [],
        excludeId: node.id,
        pathForAddSpec: pathForAddSpec,
      }),
      () => {
        // Callback function runs after state is updated
        this.getAllSpecificationList();
      },
    );
  };

  handleCloseDialogAddChildSpecification = () => {
    this.setState({
      dialogOpenAddChildSpecification: false,
      excludeId: "",
      addChildSpecName: "",
      addChildSpecDescription: "",
      addChildSpecCategory: "PSC_PROD",
      //allProductSpecifications: [],
    });
  };

  handleSubmitAddChildSpecification = () => {
    const {
      selectedChildSpecifications,
      parentSpecIdForChild,
      parentSpecNameForChild,
      parentSpecDescriptionForChild,
      parentSpecVisibilityForChild,
      parentSpecIsMandatoryForChild,
      parentSpecCategoryForChild,
    } = this.state;
    //console.log(selectedChildSpecifications,"----------dsa----------",parentSpecIdForChild);
    if (selectedChildSpecifications.length === 0) {
      console.log("no child specification selected");
      return true;
    }
    /*const payload = {
            productSpecificationRelationship: selectedChildSpecifications,
        };*/
    const payload = {
      productSpecificationRelationship: selectedChildSpecifications.map(
        (spec) => ({
          ...spec,
          action: "ADD",
        }),
      ),
    };
    this.setState({ showLoading: true });
    //console.log("--payload------", payload)
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/productSpecifications/` +
        parentSpecIdForChild,
      payload,
    )
      .then((res) => {
        this.setState({ showLoading: false });
        this.handleCloseDialogAddChildSpecification();
        this.setState({
          selectedChildSpecifications: [],
          selectedSpecificationPath: parentSpecIdForChild,
        });
        /*const parentSpecData = {
                id: parentSpecIdForChild,
                name: parentSpecNameForChild,
                description: parentSpecDescriptionForChild,
                visibility: parentSpecVisibilityForChild,
                isMandatory: parentSpecIsMandatoryForChild,
                category: parentSpecCategoryForChild,
            };*/
        //this.handleExpandUpdate(parentSpecData);
        this.getSpecificSpecificationDetail(parentSpecIdForChild);
        this.props.setErrorMessage(
          this.props.t("CHILD_SPECIFICATION_ADDED_SUCCESSFULLY"),
          true,
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        console.error("Error submitting data:", err);
      });
  };

  handleOpenDialogSpecification = () => {
    this.setState({
      dialogOpenSpecification: true,
      createDataSpecification: {},
    });
  };

  handleCloseDialogSpecification = () => {
    this.setState({
      dialogOpenSpecification: false,
      specificationFormErrors: {},
    });
  };

  handleChangeSpecification = (event) => {
    const { name, value } = event.target;
    console.log(value, name);
    if (name === "parentId") {
      const selectedValue = value ? value.id : ""; // Access the selected option's ID
      this.setState((prevState) => ({
        formDataSpecification: {
          ...prevState.formDataSpecification,
          [name]: selectedValue, // Update the specific field in the object
        },
      }));
    } else if (name === "category") {
      const selectedCategory = this.state.specCategoryList.find(
        (item) => item.id === value,
      );
      this.setState((prevState) => ({
        formDataSpecification: {
          ...prevState.formDataSpecification,
          category: selectedCategory || { id: "", name: "" },
        },
        specificationFormErrors: {
          ...prevState.specificationFormErrors,
          category: !selectedCategory || !selectedCategory.id, // Error if no selection
        },
      }));
    } else if (name === "productCategory") {
      const selectedCategory = this.state.specProductCategoryList.find(
        (item) => item.id === value,
      );
      this.setState((prevState) => ({
        formDataSpecification: {
          ...prevState.formDataSpecification,
          productCategory: selectedCategory || { id: "", name: "" },
        },
        specificationFormErrors: {
          ...prevState.specificationFormErrors,
          productCategory: !selectedCategory || !selectedCategory.id, // Error if no selection
        },
      }));
    } else {
      let error = false;
      if (name === "name") {
        error = value.trim() === ""; // Ensure name is not empty
      } else if (name === "description") {
        error = value.trim() === ""; // Ensure description is not empty
      }
      this.setState((prevState) => ({
        formDataSpecification: {
          ...prevState.formDataSpecification,
          [name]: value, // Update the specific field in the object
        },
        specificationFormErrors: {
          ...prevState.specificationFormErrors,
          [name]: error,
        },
      }));
    }
  };

  handleChangeCreateSpecification = (event) => {
    const { name, value } = event.target;
    let error = false;
    if (name === "category") {
      const selectedCategory = this.state.specCategoryList.find(
        (item) => item.id === value,
      );
      this.setState((prevState) => ({
        createDataSpecification: {
          ...prevState.createDataSpecification,
          category: selectedCategory || { id: "", name: "" },
        },
        specificationFormErrors: {
          ...prevState.specificationFormErrors,
          category: !selectedCategory || !selectedCategory.id, // Error if no selection
        },
      }));
    } else if (name === "productCategory") {
      const selectedCategory = this.state.specProductCategoryList.find(
        (item) => item.id === value,
      );
      this.setState((prevState) => ({
        createDataSpecification: {
          ...prevState.createDataSpecification,
          productCategory: selectedCategory || { id: "", name: "" },
        },
        specificationFormErrors: {
          ...prevState.specificationFormErrors,
          productCategory: !selectedCategory || !selectedCategory.id, // Error if no selection
        },
      }));
    } else {
      if (name === "name") {
        error = value.trim() === ""; // Ensure name is not empty
      } else if (name === "description") {
        error = value.trim() === ""; // Ensure description is not empty
      }
      this.setState((prevState) => ({
        createDataSpecification: {
          ...prevState.createDataSpecification,
          [name]: value, // Update the specific field in the object
        },
        specificationFormErrors: {
          ...prevState.specificationFormErrors,
          [name]: error,
        },
      }));
    }
  };

  handleSubmitSpecification = () => {
    const { formDataSpecification, selectedSpecificationId } = this.state;
    const errors = {
      productSpecCode:
        (formDataSpecification.productSpecCode ?? "").trim() === "",
      name: (formDataSpecification.name ?? "").trim() === "",
      description: (formDataSpecification.description ?? "").trim() === "",
    };

    if (!Object.values(errors).some((error) => error)) {
      this.setState({ showLoading: true });
      const specName = formDataSpecification.name;
      if (formDataSpecification.id) {
        let existingSpecificationId = formDataSpecification.id;
        //delete formDataSpecification.id;
        BusApiCall(
          "PATCH",
          `${constants.busV44UrlPublic}/productSpecifications/` +
            existingSpecificationId,
          formDataSpecification,
        )
          .then((res) => {
            this.setState({ showLoading: false });
            this.setState((prevState) => {
              // Find the tree item and update only its name and description
              const updatedTreeItems = prevState.productSpecifications.map(
                (item) =>
                  item.id === existingSpecificationId
                    ? {
                        ...item,
                        name: formDataSpecification.name,
                        description: formDataSpecification.description,
                      }
                    : item,
              );

              return {
                productSpecifications: updatedTreeItems, // Update the TreeItem without refetching
                showLoading: false,
                showSpecEditForm: false,
              };
            });
            //this.handleExpandUpdate(formDataSpecification);
            this.getSpecificSpecificationDetail(existingSpecificationId);
            //this.props.setErrorMessage(this.props.t('SPECIFICATION_UPDATED_SUCCESSFULLY'), true)
            this.props.setErrorMessage(
              this.props.t("SPECIFICATION_UPDATED_SUCCESSFULLY_NAME", {
                specName,
              }),
              true,
            );
          })
          .catch((err) => {
            this.setState({ showLoading: false, showSpecEditForm: true });
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
          });
      } else {
        BusApiCall(
          "POST",
          `${constants.busV44UrlPublic}/productSpecifications`,
          formDataSpecification,
        )
          .then((res) => {
            this.setState({
              showLoading: false,
              selectedSpecificationPath: res.data.id,
            });
            this.handleCloseDialogSpecification();
            this.setState({ showSpecEditForm: false });
            this.getSpecificationList();
            //this.props.setErrorMessage(this.props.t('SPECIFICATION_CREATED_SUCCESSFULLY'), true);
            this.props.setErrorMessage(
              this.props.t("SPECIFICATION_CREATED_SUCCESSFULLY_NAME", {
                specName,
              }),
              true,
            );
          })
          .catch((err) => {
            this.setState({ showLoading: false });
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
          });
      }
    } else {
      this.setState({ specificationFormErrors: errors });
      console.error(
        "Validation errors detected, not proceeding with API call.",
      );
    }
  };

  createSpecification = () => {
    const { createDataSpecification } = this.state;
    const errors = {
      productSpecCode:
        (createDataSpecification.productSpecCode ?? "").trim() === "",
      name: (createDataSpecification.name ?? "").trim() === "",
      description: (createDataSpecification.description ?? "").trim() === "",
    };

    if (!Object.values(errors).some((error) => error)) {
      this.setState({ showLoading: true });
      const specName = createDataSpecification.name;
      BusApiCall(
        "POST",
        `${constants.busV44UrlPublic}/productSpecifications`,
        createDataSpecification,
      )
        .then((res) => {
          this.setState({
            showLoading: false,
            selectedSpecificationPath: res.data.id,
          });
          this.handleCloseDialogSpecification();
          this.setState({ showSpecEditForm: false });
          this.getSpecificationList();
          this.props.setErrorMessage(
            this.props.t("SPECIFICATION_CREATED_SUCCESSFULLY_NAME", {
              specName,
            }),
            true,
          );
        })
        .catch((err) => {
          this.setState({ showLoading: false });
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    } else {
      this.setState({ specificationFormErrors: errors });
      console.error(
        "Validation errors detected, not proceeding with API call.",
      );
    }
  };

  handleOpenDialogAddCharacteristics = () => {
    this.getAllCharacteristicList();
    this.setState({ dialogOpenAddCharacteristics: true });
  };

  handleCloseDialogAddCharacteristics = () => {
    this.setState({
      dialogOpenAddCharacteristics: false,
      addCharacteristicName: "",
      addCharacteristicDescription: "",
      searchCategory: "-",
    });
  };

  deleteCharacteristics = (row) => {
    this.setState({ showLoading: true });
    BusApiCall(
      "DELETE",
      `${constants.busV44UrlPublic}/productCharacteristics/${row.id}/specifications/${this.state.selectedSpecificationId}`,
      "",
    )
      .then((res) => {
        this.setState({ showLoading: false });
        const charName = row.name;
        this.getCharacteristicList();
        this.props.setErrorMessage(
          this.props.t("CHARACTERISTIC_DELETED_SUCCESSFULLY_NAME", {
            charName,
          }),
          true,
        );
      })
      .catch((err) => {
        this.setState({ showLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        console.error("Error updating Product Characteristics:", err);
      });
  };

  handleSubmitAddCharacteristics = () => {
    const { selectedCharacteristics, selectedSpecificationId } = this.state;
    if (selectedCharacteristics.length === 0) {
      console.log("no characteristic selected");
      return true;
    }
    const payload = {
      productSpecCharacteristic: selectedCharacteristics,
    };
    this.setState({ showLoadingAddChar: true });
    //console.log("--payload------", payload)
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/productSpecifications/` +
        selectedSpecificationId,
      payload,
    )
      .then((res) => {
        this.setState({ showLoadingAddChar: false });
        this.handleCloseDialogAddCharacteristics();
        this.getCharacteristicList();
        this.setState({ selectedCharacteristics: [], rowCharOverrides: [] });
        this.props.setErrorMessage(
          this.props.t("CHARACTERISTIC_ADDED_SUCCESSFULLY"),
          true,
        );
      })
      .catch((err) => {
        this.setState({ showLoadingAddChar: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        console.error("Error submitting data:", err);
      });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChangeSpecSearchCate = (e) => {
    let fieldName = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (fieldName == "specificationSearchCategory") {
          this.getSpecificationList();
        }
        if (fieldName == "addChildSpecCategory") {
          this.getAllSpecificationList();
        }
      },
    );
  };

  onChangeSpecSearchProdCate = (e) => {
    let fieldName = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        //if(fieldName == 'searchSpecProductCategory'){
        this.getSpecificationList();
        //}
      },
    );
  };

  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getSpecificationList();
    }
  };

  clearSearch = () => {
    this.setState(
      {
        specificationSearchString: "",
        selectedSpecificationId: "",
        specificationSearchCategory: "-",
        searchProductSpecCode: "",
        searchSpecProductCategory: "-",
        searchVisibility: "-",
        searchIsMandatory: "-",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getSpecificationList();
      },
    );
  };

  handleToggleExpandCollapse = () => {
    const getAllNodePaths = (nodes, path = []) => {
      let allPaths = [];
      nodes.forEach((node) => {
        const currentPath = [...path, node.id];
        const pathString = currentPath.join("-");
        allPaths.push(pathString);
        if (
          node.productSpecificationRelationship &&
          node.productSpecificationRelationship.length > 0
        ) {
          allPaths = allPaths.concat(
            getAllNodePaths(node.productSpecificationRelationship, currentPath),
          );
        }
      });
      return allPaths;
    };

    if (this.state.allExpanded) {
      this.setState({
        expandedNodes: [],
        allExpanded: false,
      });
    } else {
      const allNodePaths = getAllNodePaths(this.state.productSpecifications);
      this.setState({
        expandedNodes: allNodePaths,
        allExpanded: true,
      });
    }
  };

  clearSearchCharacteristic = () => {
    this.setState(
      {
        name: "",
        characteristicDescription: "",
        pageCharacteristics: 1,
        startRecordCharacteristics: 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getSpecificationList();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getSpecificationList();
      },
    );
  };

  handleChangePageCharacteristics = (event, newPage) => {
    this.setState(
      {
        pageCharacteristics: newPage,
        startRecordCharacteristics:
          this.state.rowsPerPageCharacteristics * (newPage - 1) + 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  handleChangeRowsPerPageCharacteristics = (event) => {
    this.setState(
      {
        pageCharacteristics: 1,
        rowsPerPageCharacteristics: event.target.value,
        startRecordCharacteristics: 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  handleChangePageAllCharacteristics = (event, newPage) => {
    this.setState(
      {
        pageAllCharacteristics: newPage,
        startRecordAllCharacteristics:
          this.state.rowsPerPageAllCharacteristics * (newPage - 1) + 1,
      },
      () => {
        this.getAllCharacteristicList();
      },
    );
  };

  handleChangeRowsPerPageAllCharacteristics = (event) => {
    this.setState(
      {
        pageAllCharacteristics: 1,
        rowsPerPageAllCharacteristics: event.target.value,
        startRecordAllCharacteristics: 1,
      },
      () => {
        this.getAllCharacteristicList();
      },
    );
  };

  clearSearchAllCharacteristic = () => {
    this.setState(
      {
        addCharacteristicName: "",
        addCharacteristicDescription: "",
        searchCategory: "-",
        pageAllCharacteristics: 1,
        startRecordAllCharacteristics: 1,
      },
      () => {
        this.getAllCharacteristicList();
      },
    );
  };

  goToCharacteristic = () => {
    this.props.router.navigate("/characteristic");
  };

  syncCharacteristics = (specId, id) => {
    const formData = { specId: specId, id: id };
    this.setState({ showLoading: true });
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/SYNC_PROD_CHAR_VAL/endpoint`,
      formData,
    )
      .then((res) => {
        this.setState({ showLoading: false });
        console.log(res.data);
        if (res.data.errorMessage) {
          //this.props.setErrorMessage(this.props.t('CHARACTERISTICS_SYNC_SUCCESSFULLY'), true);
          this.props.setErrorMessage(res.data.errorMessage, false);
        }
      })
      .catch((err) => {
        this.setState({ showLoading: false });
        console.error("Error syncing product characteristics:", err);
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  selectSpecificationDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent dialogHeight"
        handle="#select-specification-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} style={{ height: "380px" }} />
      </Draggable>
    );
  };

  selectChildSpecDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent dialogHeight"
        handle="#select-ChildSpec-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} style={{ height: "500px" }} />
      </Draggable>
    );
  };
  selectDeleteChildSpecDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent dialogHeight"
        handle="#select-deleteChildSpec-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} style={{ height: "210px" }} />
      </Draggable>
    );
  };

  selectAddCharacteristicDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent dialogHeight"
        handle="#select-add-characteristic-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} style={{ height: "500px" }} />
      </Draggable>
    );
  };
  selectAddChildSpecDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent dialogHeight"
        handle="#add-child-spec-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} style={{ height: "500px" }} />
      </Draggable>
    );
  };

  selectCharacteristicDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent dialogHeight"
        handle="#select-characteristic-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} style={{ height: "500px" }} />
      </Draggable>
    );
  };

  toggleShowSpecificationList = (type) => {
    if (type == "list") {
      this.setState({ showSpecificationList: true });
    } else {
      this.setState({ showSpecificationList: false });
    }
  };

  toggleSpecInfoForm = () => {
    console.log(this.state.formDataSpecification);
    this.setState((prevState) => ({
      showSpecEditForm: !this.state.showSpecEditForm,
      formDataSpecification: {
        ...prevState.formDataSpecification,
        name: prevState.selectedSpecificationName,
        productSpecCode: prevState.selectedProductSpecCode,
        description: prevState.selectedSpecificationDescription,
        visibility: prevState.selectedSpecificationVisibility,
        isMandatory: prevState.selectedSpecificationIsMandatory,
        category: prevState.selectedSpecificationCategory,
        productCategory: prevState.selectedSpecificationProductCategory,
        id: prevState.selectedSpecificationId,
        // Todo for childspecifications list display
      },
    }));
    //console.log("=========selectedNodes=============", this.state.selectedNodes)
  };

  handleCheckboxChange = (event, selectedCharacteristicId) => {
    const isChecked = event.target.checked;
    this.setState((prevState) => {
      let updatedCharacteristics = [...prevState.selectedCharacteristics];
      if (isChecked) {
        // Add characteristic if checked
        updatedCharacteristics.push({
          id: selectedCharacteristicId,
          //overrideBehavior: prevState.rowCharOverrides[selectedCharacteristicId] || "" // use saved value if exists
        });
      } else {
        // Remove characteristic if unchecked
        updatedCharacteristics = updatedCharacteristics.filter(
          (char) => char.id !== selectedCharacteristicId,
        );
      }

      return { selectedCharacteristics: updatedCharacteristics };
    });
  };

  //    onChangeOverrideBehavior = (value, selectedCharacteristicId) => {
  //        this.setState((prevState) => {
  //            const rowCharOverrides = { ...prevState.rowCharOverrides, [selectedCharacteristicId]: value };
  //
  //            let updatedCharacteristics = [...prevState.selectedCharacteristics];
  //            const index = updatedCharacteristics.findIndex((char) => char.id === selectedCharacteristicId);
  //            if (index >= 0) {
  //                updatedCharacteristics[index].overrideBehavior = value;
  //            }
  //
  //            return { rowCharOverrides, selectedCharacteristics: updatedCharacteristics };
  //        });
  //    };

  handleOpenDialogCharacteristics = (row, action) => {
    const selectedCharacteristicsByType = {};
    let listCharRelations = [];
    if (row.charRelations && row.charRelations.length > 0) {
      listCharRelations = row.charRelations;
      row.relationshipType = listCharRelations[0].type;
      listCharRelations.forEach(
        ({ idTo, type, specIdTo, name, valueType, nameSpace }) => {
          if (!selectedCharacteristicsByType[type]) {
            selectedCharacteristicsByType[type] = [];
          }
          selectedCharacteristicsByType[type].push({
            id: idTo,
            specId: specIdTo,
            name,
            valueType,
            nameSpace,
          });
        },
      );
    }
    const initialSelectedCharacteristicsByType = JSON.parse(
      JSON.stringify(selectedCharacteristicsByType),
    );
    //console.log("=============initialSelectedCharacteristicsByType=============",initialSelectedCharacteristicsByType)
    this.setState({
      dialogOpenCharacteristics: true,
      formDataCharacteristics: row,
      actionType: action,
      enumerationValues: [],
      selectedCharacteristicsByType,
      initialSelectedCharacteristicsByType,
    });
  };

  handleCloseDialogCharacteristics = () => {
    this.setState({
      dialogOpenCharacteristics: false,
      characteristicsFormErrors: {},
      isCreatingNewEnum: false,
      newEnumValue: "",
    });
  };

  handleOpenDialogChildSpec = (row, action) => {
    this.setState({
      dialogOpenChildSpec: true,
      formDataChildSpec: row,
      childSpecActionType: action,
    });
  };

  handleCloseDialogChildSpec = () => {
    this.setState({ dialogOpenChildSpec: false });
  };

  handleOpenDialogDeleteChildSpec = (row) => {
    this.setState({
      showDeleteChildSpecConfirmDialog: true,
      deleteChildSpecId: row.id,
    });
  };

  decodeHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent;
  };

  capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  handleEnumValueDropdownChange = (newValue) => {
    let isValid = this.validateFormat(
      newValue,
      this.state.formDataCharacteristics.format,
    );

    this.setState((prevState) => {
      // reset enumerationValues so only newValue is default
      const updatedEnumerationValues = (
        prevState.formDataCharacteristics.characteristicValueSpecification || []
      ).map((v) => ({
        ...v,
        isDefault: v.value === newValue,
      }));

      return {
        formDataCharacteristics: {
          ...prevState.formDataCharacteristics,
          value: isValid ? newValue : "",
          characteristicValueSpecification: updatedEnumerationValues,
        },
        characteristicsFormErrors: {
          ...prevState.characteristicsFormErrors,
          value: !isValid,
        },
      };
    });
  };

  handleEnumValueDropdownChangeOld = (newValue) => {
    console.log(
      "-------handleEnumValueDropdownChange-----------newValue------------------",
      newValue,
    );
    let isValid = this.validateFormat(
      newValue,
      this.state.formDataCharacteristics.format,
    );
    this.setState((prevState) => ({
      formDataCharacteristics: {
        ...prevState.formDataCharacteristics,
        value: isValid ? newValue : "",
      },
      characteristicsFormErrors: {
        ...prevState.characteristicsFormErrors,
        value: !isValid,
      },
    }));
    //this.setState({ newEnumValue: newValue });
  };

  validateFormat = (value, format) => {
    if (!format || !value || value === "-") return true;

    try {
      const regex = new RegExp(`^(${format})$`, "i");
      return regex.test(value);
    } catch (error) {
      //console.error("Invalid regex format:", format);
      return true; // Allow it if the regex is broken
    }
  };

  handleCharacteristicError = (errorField, hasError) => {
    this.setState((prevState) => ({
      characteristicsFormErrors: {
        ...prevState.characteristicsFormErrors,
        [errorField]: hasError,
      },
    }));
  };

  handleDeleteEnumerationValue = (updatedValues) => {
    this.setState((prevState) => ({
      formDataCharacteristics: {
        ...prevState.formDataCharacteristics,
        characteristicValueSpecification: updatedValues,
      },
    }));
  };

  handleEnumerationChange = (updatedValues) => {
    console.log("updatedValues enum Value:----", updatedValues);
    console.log(
      "format enum Value:",
      this.state.formDataCharacteristics.format,
    );
    this.setState((prevState) => {
      // Ensure values exists and is an array
      const existingValues = Array.isArray(
        prevState.formDataCharacteristics.characteristicValueSpecification,
      )
        ? prevState.formDataCharacteristics.characteristicValueSpecification
        : [];

      // Merge new values without duplicates
      const uniqueValues = [
        ...existingValues, // Keep existing values
        ...updatedValues.filter(
          (newVal) =>
            !existingValues.some((oldVal) => oldVal.value === newVal.value),
        ),
      ];

      return {
        //enumerationValues: updatedValues, // Store only newly added values
        formDataCharacteristics: {
          ...prevState.formDataCharacteristics,
          characteristicValueSpecification: uniqueValues, // Ensure list remains unique
        },
      };
    });
  };

  handleChangeCharacteristics = (event) => {
    const { name, value } = event.target;
    if (name === "category") {
      const selectedCategory = this.state.charCategoryList.find(
        (item) => item.id === value,
      );
      this.setState((prevState) => ({
        formDataCharacteristics: {
          ...prevState.formDataCharacteristics,
          category: selectedCategory || { id: "", name: "" },
        },
        characteristicsFormErrors: {
          ...prevState.characteristicsFormErrors,
          category: !selectedCategory || !selectedCategory.id, // Error if no selection
        },
      }));
    } else {
      //console.log(name, value);
      let error = false;
      let updatedValue = value;
      let resetValue = this.state.formDataCharacteristics.value; // Preserve previous value

      if (name === "valueType") {
        resetValue = "";
      }
      if (name === "value" && value !== "") {
        /*const selectedType = this.state.formDataCharacteristics.type;
                if (selectedType === "NUMBER") {
                    error = !/^\d*$/.test(value); // Ensure only numeric input
                } else if (selectedType === "BOOLEAN") {
                    error = !["true", "false"].includes(value); // Ensure only true/false
                } else if (selectedType === "ENUMERATION") {
                    error = value.trim() === ""; // Ensure a valid selection
                }*/
      } else if (name === "valueType") {
        error = value === "-"; // Ensure a valid option is selected
      } else if (name === "name") {
        error = value.trim() === ""; // Ensure description is not empty
      } else if (name === "description") {
        error = value.trim() === ""; // Ensure description is not empty
      }
      this.setState((prevState) => ({
        formDataCharacteristics: {
          ...prevState.formDataCharacteristics,
          [name]: updatedValue, // Update the specific field
          ...(name === "valueType" && { value: resetValue }), // Reset value if type changes
        },
        characteristicsFormErrors: {
          ...prevState.characteristicsFormErrors,
          [name]: error,
        },
      }));
    }
  };

  handleSubmitCharacteristics = () => {
    const { value, valueType, name, description, id } =
      this.state.formDataCharacteristics;
    //const specId = this.state.formDataCharacteristics.specId;

    /* const formattedList = Object.entries(this.state.selectedCharacteristicsByType).flatMap(
           ([type, ids]) => {
             const originalIds = this.state.initialSelectedCharacteristicsByType?.[type] || [];
 
             const addedIds = ids.filter(id => !originalIds.includes(id));
             const removedIds = originalIds.filter(id => !ids.includes(id));
 
             return [
               ...addedIds.map(id => ({ idTo: id, type, action: "ADD" })),
               ...removedIds.map(id => ({ idTo: id, type, action: "DELETE" })),
             ];
           }
         );*/
    const formattedList = Object.entries(
      this.state.selectedCharacteristicsByType,
    ).flatMap(([type, items]) => {
      const originalItems =
        this.state.initialSelectedCharacteristicsByType?.[type] || [];

      const originalKeys = new Set(
        originalItems.map((item) => `${item.id}_${item.specId}`),
      );
      const currentKeys = new Set(
        items.map((item) => `${item.id}_${item.specId}`),
      );

      const addedItems = items.filter(
        (item) => !originalKeys.has(`${item.id}_${item.specId}`),
      );
      const removedItems = originalItems.filter(
        (item) => !currentKeys.has(`${item.id}_${item.specId}`),
      );

      return [
        ...addedItems.map((item) => ({
          idTo: item.id,
          specIdTo: item.specId,
          type,
          action: "ADD",
        })),
        ...removedItems.map((item) => ({
          idTo: item.id,
          specIdTo: item.specId,
          type,
          action: "DELETE",
        })),
      ];
    });

    //console.log(formattedList);

    const errors = {
      valueType: (valueType ?? "-") === "-",
      name: (name ?? "").trim() === "",
      description: (description ?? "").trim() === "",
    };

    const updatedFormData = {
      ...this.state.formDataCharacteristics,
      //specId,
      value:
        this.state.newEnumValue || this.state.formDataCharacteristics.value,
      enumerationValues: this.state.formDataCharacteristics.enumerationValues,
      charRelations: formattedList,
    };
    //console.log("--------this.state.formDataCharacteristics.enumerationValues-------",this.state.formDataCharacteristics.enumerationValues)
    //delete updatedFormData.values;
    //console.log("--------updatedFormData-----",updatedFormData)
    this.setState(
      {
        formDataCharacteristics: updatedFormData,
        errors,
        characteristicsFormErrors: errors,
      },
      () => {
        // Proceed only if there are no validation errors
        if (!Object.values(errors).some((error) => error)) {
          this.setState({ showLoading: true });

          const apiMethod = id ? "PATCH" : "POST";
          const apiUrl = id
            ? `${constants.busV44UrlPublic}/productCharacteristics/${id}`
            : `${constants.busV44UrlPublic}/productCharacteristics`;
          const charName = name;
          const transformPayload = toApi(this.state.formDataCharacteristics);
          BusApiCall(apiMethod, apiUrl, transformPayload)
            .then((res) => {
              this.setState({ showLoading: false });
              if (res.data.responseMessage === "error") {
                //this.handleCloseDialogCharacteristics();
                //this.getCharacteristicList();
                //this.props.setErrorMessage(res.data.errorMessage, false);
                this.showResponseMessage(res.data.errorMessage, "error");
              } else {
                if (res.data) {
                  this.setState({ selectedCharacteristicsByType: {} });
                  this.handleCloseDialogCharacteristics();
                  // Don't need to call this, we directly sync the characteristics in updateCharacteristics service from backend
                  //this.syncCharacteristics(this.state.selectedSpecificationId,id);
                  this.getCharacteristicList();
                  if (id) {
                    this.props.setErrorMessage(
                      this.props.t("CHARACTERISTIC_UPDATED_SUCCESSFULLY_NAME", {
                        charName,
                      }),
                      true,
                    );
                  } else {
                    this.props.setErrorMessage(
                      this.props.t("CHARACTERISTIC_CREATED_SUCCESSFULLY_NAME", {
                        charName,
                      }),
                      true,
                    );
                  }
                } else {
                  console.error(
                    "Error in Product Characteristics API response",
                  );
                }
              }
            })
            .catch((err) => {
              this.setState({ showLoading: false });
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                //this.props.setErrorMessage(err.response.data.message, false);
                this.showResponseMessage(err.response.data.message, "error");
                //this.handleCloseDialogCharacteristics();
                //this.getCharacteristicList();
              } else {
                this.showResponseMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  "error",
                );
                //this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
              }
              console.error("Error in Product Characteristics API:", err);
            });
        } else {
          console.error(
            "Validation errors detected, not proceeding with API call.",
          );
        }
      },
    );
  };

  renderAttributesFields = () => {
    const {
      productCharacteristics,
      selectedCharacteristicsByType,
      formDataCharacteristics,
    } = this.state;
    const relationshipType = formDataCharacteristics.relationshipType;
    const parentTypeId = formDataCharacteristics?.valueType?.toUpperCase();

    const allSelectedPairs = Object.values(
      selectedCharacteristicsByType,
    ).flat();
    const currentSelectedPairs =
      selectedCharacteristicsByType[relationshipType] || [];
    const allSelectedKeySet = new Set(
      allSelectedPairs.map((item) => `${item.id}_${item.specId}`),
    );
    const currentSelectedKeySet = new Set(
      currentSelectedPairs.map((item) => `${item.id}_${item.specId}`),
    );
    const baseCharacteristics =
      relationshipType === "FEATURE_IACTN_MAPPED"
        ? this.state.productCharacteristicsForSameAsRelationship
        : this.state.productCharacteristics;

    const filteredOptions = baseCharacteristics.filter((item) => {
      const key = `${item.id}_${item.specId}`;
      const isAlreadySelected =
        allSelectedKeySet.has(key) && !currentSelectedKeySet.has(key);
      const isCurrentEditing = item.id === formDataCharacteristics.id;
      return !isAlreadySelected && !isCurrentEditing;
    });

    /*const mergedOptions = [
          ...filteredOptions.filter(
            (option) =>
              !currentSelectedPairs.some(
                (selected) => selected.id === option.id && selected.specId === option.specId
              )
          ),
          ...currentSelectedPairs,
        ];*/
    const keySet = new Set();
    const mergedOptions = [];

    for (const item of [...currentSelectedPairs, ...filteredOptions]) {
      const key = `${item.id}_${item.specId}`;
      if (!keySet.has(key)) {
        mergedOptions.push(item);
        keySet.add(key);
      }
    }

    return (
      <>
        <Grid
          item
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder="Tags"
            name="tag"
            divClass={classes.inputClass}
            // value={this.state.formDataCharacteristics.tag?? ""}
            value={
              this.state.actionType === "view" &&
              !this.state.formDataCharacteristics.tag
                ? " "
                : (this.state.formDataCharacteristics.tag ?? "")
            }
            disabled={this.state.actionType === "view"}
            onChange={this.handleChangeCharacteristics}
          />
        </Grid>
        <Grid
          item
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <FormControl
            variant="outlined"
            size="small"
            className={classes.customeSelectLabel}
          >
            <InputLabel
              id="relationshipTypeLabel"
              style={{ background: "#fff" }}
              shrink
            >
              Relationship Type
            </InputLabel>
            <Select
              size="small"
              variant="outlined"
              name="relationshipType"
              value={this.state.formDataCharacteristics.relationshipType ?? ""}
              native
              label="Relationship Type"
              labelId="relationshipTypeLabel"
              error={this.state.relationshipCharacteristicsError}
              disabled={this.state.actionType === "view"}
              onChange={(e) => {
                const relationshipTypeId = e.target.value;
                this.setState((prev) => ({
                  formDataCharacteristics: {
                    ...prev.formDataCharacteristics,
                    relationshipType: relationshipTypeId,
                  },
                  relationshipType: relationshipTypeId,
                  relationshipCharacteristicsError: false,
                }));
              }}
            >
              <option value="-">Select</option>
              <option value="FEATURE_IACTN_DEPEND">Dependent</option>
              <option value="FEATURE_IACTN_INCOMP">Incompatible</option>
              <option value="FEATURE_IACTN_MAPPED">Same As</option>
            </Select>
          </FormControl>
          {this.state.relationshipCharacteristicsError && (
            <p className="text-error" style={{ marginTop: "4px" }}>
              First select relationship type.
            </p>
          )}
        </Grid>
        <Grid
          item
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Autocomplete
            multiple
            disableCloseOnSelect
            limitTags={1}
            className="customAutoCompleteMain"
            options={mergedOptions}
            getOptionSelected={(option, value) => {
              return option.id === value.id && option.specId === value.specId;
            }}
            loading={this.state.showLoadingProgress}
            getOptionLabel={(option) => {
              if (!option) return "-";
              if (option?.id === "") return "-";
              {
                /*const specName = option.specName ? this.decodeHtml(option.specName) + ' : ' : '';*/
              }
              const name = option.name ? this.decodeHtml(option.name) : "";
              const nameSpace = option.nameSpace
                ? this.decodeHtml(option.nameSpace) + " : "
                : "";
              var rawType = option.valueType?.toUpperCase();
              let valueType = "";
              if (rawType === "ENUMERATION" || rawType === "ENUM") {
                valueType = "Enum";
              } else if (option.valueType) {
                valueType = this.capitalizeFirstLetter(option.valueType);
              }

              return `${nameSpace}${name} (${valueType})`;
            }}
            getOptionDisabled={(option) => {
              if (relationshipType !== "FEATURE_IACTN_MAPPED") return false;
              var rawTypeId = option.valueType?.toUpperCase();

              if (parentTypeId === "ENUMERATION" || parentTypeId === "ENUM") {
                return rawTypeId !== "ENUMERATION" && rawTypeId !== "ENUM";
              } else if (parentTypeId === "BOOLEAN") {
                const disallowedTypes = [
                  "DATE",
                  "DATETIME",
                  "DECIMAL",
                  "NUMBER",
                  "ENUMERATION",
                  "ENUM",
                ];
                return disallowedTypes.includes(rawTypeId);
              } else if (
                parentTypeId === "NUMBER" ||
                parentTypeId === "DECIMAL"
              ) {
                const disallowedTypes = [
                  "DATE",
                  "DATETIME",
                  "ENUMERATION",
                  "ENUM",
                ];
                return disallowedTypes.includes(rawTypeId);
              } else if (
                parentTypeId === "DATE" ||
                parentTypeId === "DATETIME"
              ) {
                const disallowedTypes = [
                  "BOOLEAN",
                  "NUMBER",
                  "DECIMAL",
                  "ENUMERATION",
                  "ENUM",
                ];
                return disallowedTypes.includes(rawTypeId);
              } else {
                return rawTypeId === "ENUMERATION" || rawTypeId === "ENUM";
              }
            }}
            /*value={
                          this.state.actionType === 'view' && currentSelectedIds.length === 0
                            ? [{ id: '', name: '-', type: '' }]
                            : currentSelectedIds.map((id) =>
                                baseCharacteristics.find((item) => item.id === id)
                              )
                        }*/
            value={
              this.state.actionType === "view" &&
              currentSelectedPairs.length === 0
                ? [{ id: "", name: "-", valueType: "" }]
                : currentSelectedPairs
                    .map((pair) =>
                      mergedOptions.find(
                        (item) =>
                          item.id === pair.id && item.specId === pair.specId,
                      ),
                    )
                    .filter(Boolean) // remove any unmatched items
            }
            onChange={(e, newValue) => {
              //const ids = newValue.map((item) => item.id);
              const idsWithSpecId = newValue.map((item) => ({
                id: item.id,
                specId: item.specId,
                name: item.name,
                valueType: item.valueType,
                nameSpace: item.nameSpace,
              }));
              if (relationshipType !== undefined && relationshipType !== "-") {
                this.setState({ relationshipCharacteristicsError: false });
                this.setState((prev) => ({
                  selectedCharacteristicsByType: {
                    ...prev.selectedCharacteristicsByType,
                    [relationshipType]: idsWithSpecId,
                  },
                }));
              } else {
                this.setState({ relationshipCharacteristicsError: true });
              }
              this.setState({ inputValue: "" });
            }}
            inputValue={this.state.inputValue} // ✅ this line
            onInputChange={(event, newInputValue, reason) => {
              if (reason === "input") {
                this.setState({ inputValue: newInputValue }); // ✅ update inputValue state
                if (relationshipType === "FEATURE_IACTN_MAPPED") {
                  this.refetchCharacteristicListForSameAsRelationship(
                    newInputValue,
                  );
                }
              } else if (reason === "clear") {
                this.setState({ inputValue: "" });
              }
            }}
            disabled={this.state.actionType === "view"}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                size="small"
                label="Relationship Characteristics"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {this.state.showLoadingProgress ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid
          item
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Input
            size="small"
            variant="outlined"
            placeholder="Sequence Number"
            name="sequenceNum"
            type="text"
            error={this.state.characteristicsFormErrors.sequenceNum}
            value={
              this.state.actionType === "view" &&
              !this.state.formDataCharacteristics.sequenceNum
                ? " "
                : (this.state.formDataCharacteristics.sequenceNum ?? "")
            }
            disabled={this.state.actionType === "view"}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*\.?\d*$/.test(value)) {
                this.handleChangeCharacteristics(e);
              }
            }}
          />
          {this.state.characteristicsFormErrors.sequenceNum && (
            <p className="text-error" style={{ marginTop: "4px" }}>
              {this.state.characteristicsFormErrors.sequenceNum}
            </p>
          )}
        </Grid>
      </>
    );
  };

  renderInputField = () => {
    const { t } = this.props;
    const { valueType } = this.state.formDataCharacteristics;
    const { characteristicsFormErrors } = this.state;
    //        console.log('-------------values-----',this.state.formDataCharacteristics);
    switch (valueType?.toUpperCase()) {
      case "BOOLEAN":
        return (
          <FormControl
            variant="outlined"
            size="small"
            className={classes.customeSelectLabel}
            error={!!this.state.characteristicsFormErrors.value}
            fullWidth
          >
            <InputLabel
              id="booleanValueLabel"
              style={{ background: "#fff" }}
              shrink
            >
              Value
            </InputLabel>
            <Select
              labelId="booleanValueLabel"
              size="small"
              variant="outlined"
              name="value"
              value={this.state.formDataCharacteristics.value || ""}
              onChange={this.handleChangeCharacteristics}
              native
              label="Value"
              disabled={this.state.actionType === "view"}
            >
              <option value="-">Select</option>
              <option value="true">True</option>
              <option value="false">False</option>
            </Select>
            {this.state.characteristicsFormErrors.value && (
              <p className="text-error" style={{ marginTop: "4px" }}>
                Please select a valid value.
              </p>
            )}
          </FormControl>
        );

      case "NUMBER":
        return (
          <>
            <Input
              size="small"
              variant="outlined"
              placeholder="Value"
              name="value"
              type="text"
              error={!!this.state.characteristicsFormErrors.value}
              value={
                this.state.actionType === "view" &&
                !this.state.formDataCharacteristics.value
                  ? " "
                  : (this.state.formDataCharacteristics.value ?? "")
              }
              disabled={this.state.actionType === "view"}
              onChange={(e) => {
                const { format } = this.state.formDataCharacteristics;
                const value = e.target.value;

                // Allow the user to type freely
                this.handleChangeCharacteristics(e);
              }}
              onBlur={(e) => {
                const { format, value } = this.state.formDataCharacteristics;

                if (format && value) {
                  try {
                    const regex = new RegExp(format);
                    if (!regex.test(value)) {
                      this.setState((prevState) => ({
                        formDataCharacteristics: {
                          ...prevState.formDataCharacteristics,
                          value: "",
                        },
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          //value: `Value does not match the ${t("VALIDATION_FORMAT")}:- `+format,
                          value: `${t("VALIDATION_FORMAT_MSG")}:- ` + format,
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          value: "",
                        },
                      }));
                    }
                  } catch (error) {
                    console.error("Invalid regex format:", format);
                  }
                } else {
                  this.setState((prevState) => ({
                    formDataCharacteristics: {
                      ...prevState.formDataCharacteristics,
                      value: isNaN(value) ? "" : value,
                    },
                    characteristicsFormErrors: {
                      ...prevState.characteristicsFormErrors,
                      value: isNaN(value) ? "Value must be numeric." : "",
                    },
                  }));
                }
              }}
            />
            {this.state.characteristicsFormErrors.value && (
              <p className="text-error" style={{ marginTop: "4px" }}>
                {this.state.characteristicsFormErrors.value}
              </p>
            )}
          </>
        );

      case "DECIMAL":
        return (
          <>
            <Input
              size="small"
              variant="outlined"
              placeholder="Value"
              name="value"
              type="text"
              error={!!this.state.characteristicsFormErrors.value}
              value={
                this.state.actionType === "view" &&
                !this.state.formDataCharacteristics.value
                  ? " "
                  : (this.state.formDataCharacteristics.value ?? "")
              }
              disabled={this.state.actionType === "view"}
              onChange={(e) => {
                const { format } = this.state.formDataCharacteristics;
                const value = e.target.value;

                // Allow the user to type freely
                this.handleChangeCharacteristics(e);
              }}
              onBlur={(e) => {
                const { format, value } = this.state.formDataCharacteristics;

                if (format && value) {
                  try {
                    const regex = new RegExp(format);
                    if (!regex.test(value)) {
                      this.setState((prevState) => ({
                        formDataCharacteristics: {
                          ...prevState.formDataCharacteristics,
                          value: "",
                        },
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          //value: `Value does not match the ${t("VALIDATION_FORMAT")}:- `+format,
                          value: `${t("VALIDATION_FORMAT_MSG")}:- ` + format,
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          value: "",
                        },
                      }));
                    }
                  } catch (error) {
                    console.error("Invalid regex format:", format);
                  }
                } else {
                  this.setState((prevState) => ({
                    formDataCharacteristics: {
                      ...prevState.formDataCharacteristics,
                      value: isNaN(value) ? "" : value,
                    },
                    characteristicsFormErrors: {
                      ...prevState.characteristicsFormErrors,
                      value: isNaN(value)
                        ? "Value must be a valid decimal number."
                        : "",
                    },
                  }));
                }
              }}
            />

            {this.state.characteristicsFormErrors.value && (
              <p className="text-error" style={{ marginTop: "4px" }}>
                {this.state.characteristicsFormErrors.value}
              </p>
            )}
          </>
        );

      case "DATETIME":
        return (
          <>
            <FormControl
              variant="outlined"
              size="small"
              fullWidth
              error={!!this.state.characteristicsFormErrors.value}
            >
              <InputLabel
                style={{ background: "#fff" }}
                id="DateTimeValueLabel"
                shrink
              >
                DD-MM-YYYY HH:MM
              </InputLabel>
              <Input
                size="small"
                variant="outlined"
                //placeholder="YYYY-MM-DD HH:MM:SS"
                labelId="DateTimeValueLabel"
                name="value"
                type="datetime-local"
                //error={this.state.characteristicsFormErrors.value}
                //value={this.state.formDataCharacteristics.value||''}
                value={normalizeDateTime(
                  this.state.formDataCharacteristics.value,
                )}
                disabled={this.state.actionType === "view"}
                onChange={this.handleChangeCharacteristics}
                onBlur={(e) => {
                  const value = e.target.value;
                  // Validate datetime format (YYYY-MM-DDTHH:MM)
                  if (!value) {
                    this.setState((prevState) => ({
                      characteristicsFormErrors: {
                        ...prevState.characteristicsFormErrors,
                        value: "Please enter a valid date and time.",
                      },
                    }));
                  } else {
                    this.setState((prevState) => ({
                      characteristicsFormErrors: {
                        ...prevState.characteristicsFormErrors,
                        value: "",
                      },
                    }));
                  }
                }}
              />
              {this.state.characteristicsFormErrors.value && (
                <p className="text-error" style={{ marginTop: "4px" }}>
                  {this.state.characteristicsFormErrors.value}
                </p>
              )}
            </FormControl>
          </>
        );

      case "DATE":
        return (
          <>
            <FormControl
              variant="outlined"
              size="small"
              fullWidth
              error={!!this.state.characteristicsFormErrors.value}
            >
              <InputLabel
                style={{ background: "#fff" }}
                id="DateValueLabel"
                shrink
              >
                DD-MM-YYYY
              </InputLabel>
              <Input
                size="small"
                variant="outlined"
                //placeholder="YYYY-MM-DD"
                labelId="DateValueLabel"
                name="value"
                type="date"
                //error={this.state.characteristicsFormErrors.value}
                value={
                  this.state.actionType === "view" &&
                  !this.state.formDataCharacteristics.value
                    ? " "
                    : (this.state.formDataCharacteristics.value ?? "")
                }
                disabled={this.state.actionType === "view"}
                onChange={this.handleChangeCharacteristics}
                onBlur={(e) => {
                  const value = e.target.value;
                  // Validate date format
                  if (!value) {
                    this.setState((prevState) => ({
                      characteristicsFormErrors: {
                        ...prevState.characteristicsFormErrors,
                        value: "Please enter a valid date.",
                      },
                    }));
                  } else {
                    this.setState((prevState) => ({
                      characteristicsFormErrors: {
                        ...prevState.characteristicsFormErrors,
                        value: "",
                      },
                    }));
                  }
                }}
              />
              {this.state.characteristicsFormErrors.value && (
                <p className="text-error" style={{ marginTop: "4px" }}>
                  {this.state.characteristicsFormErrors.value}
                </p>
              )}
            </FormControl>
          </>
        );

      case "ENUMERATION":
      case "ENUM":
        return (
          <div>
            {/*<CustomDropdown onEnumerationChange={this.handleEnumerationChange} onDeleteEnumerationValue={this.handleDeleteEnumerationValue} onErrorChange={this.handleCharacteristicError} onSelectChange={this.handleEnumValueDropdownChange} options={this.state.formDataCharacteristics.enumerationValues} defaultValue={this.state.formDataCharacteristics.value} formatValue={this.state.formDataCharacteristics.format} actionType={this.state.actionType}/>*/}
            <CustomDropdown
              onEnumerationChange={this.handleEnumerationChange}
              onDeleteEnumerationValue={this.handleDeleteEnumerationValue}
              onErrorChange={this.handleCharacteristicError}
              onSelectChange={this.handleEnumValueDropdownChange}
              options={
                this.state.formDataCharacteristics
                  .characteristicValueSpecification
              }
              defaultValue={
                this.state.formDataCharacteristics
                  .characteristicValueSpecification &&
                this.state.formDataCharacteristics.characteristicValueSpecification.find(
                  (v) => v.isDefault,
                )?.value
              }
              formatValue={this.state.formDataCharacteristics.format}
              actionType={this.state.actionType}
            />
            {this.state.characteristicsFormErrors.value && (
              <p className="text-error" style={{ marginTop: "4px" }}>
                Invalid value. Allowed:{" "}
                {this.state.formDataCharacteristics.format.replace(/\|/g, ", ")}
                {/*Value does not match the {t("VALIDATION_FORMAT")}:- {this.state.formDataCharacteristics.format}*/}
              </p>
            )}
          </div>
        );
      default:
        return (
          <>
            <Input
              size="small"
              variant="outlined"
              placeholder="Value"
              name="value"
              type="text"
              error={!!this.state.characteristicsFormErrors.value}
              value={
                this.state.actionType === "view" &&
                !this.state.formDataCharacteristics.value
                  ? " "
                  : (this.state.formDataCharacteristics.value ?? "")
              }
              disabled={this.state.actionType === "view"}
              onChange={(e) => {
                const { format } = this.state.formDataCharacteristics;
                const value = e.target.value;
                this.handleChangeCharacteristics(e);
              }}
              onBlur={(e) => {
                const { format, value } = this.state.formDataCharacteristics;

                if (format && value) {
                  try {
                    const regex = new RegExp(format);
                    if (!regex.test(value)) {
                      this.setState((prevState) => ({
                        formDataCharacteristics: {
                          ...prevState.formDataCharacteristics,
                          value: "",
                        },
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          //value: `Value does not match the ${t("VALIDATION_FORMAT")}:- `+format,
                          value: `${t("VALIDATION_FORMAT_MSG")}:- ` + format,
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        characteristicsFormErrors: {
                          ...prevState.characteristicsFormErrors,
                          value: "",
                        },
                      }));
                    }
                  } catch (error) {
                    console.error("Invalid regex format:", format);
                  }
                }
              }}
            />
            {this.state.characteristicsFormErrors.value && (
              <p className="text-error" style={{ marginTop: "4px" }}>
                {this.state.characteristicsFormErrors.value}
              </p>
            )}
          </>
        );
    }
  };
  renderCategoryField = () => {
    const { t } = this.props;
    return (
      <Grid
        item
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <FormControl
          variant="outlined"
          size="small"
          className={classes.customeSelectLabel}
        >
          <InputLabel id="categoryLabel" style={{ background: "#fff" }} shrink>
            {t("CATEGORY")}
          </InputLabel>
          <Select
            size="small"
            variant="outlined"
            name="category"
            value={this.state.formDataCharacteristics.category?.id ?? ""}
            native
            label="Category"
            labelId="categoryLabel"
            disabled={this.state.actionType === "view"}
            onChange={this.handleChangeCharacteristics}
          >
            <option value="-">Select</option>
            {this.state.charCategoryList.map((item) => (
              <option key={item.id} value={item.id}>
                {this.decodeHtml(item.name)}
              </option>
            ))}
          </Select>
        </FormControl>
      </Grid>
    );
  };

  renderExternalIdField = () => {
    return (
      <Grid
        item
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Input
          size={"small"}
          variant={"outlined"}
          placeholder="External Code"
          name="externalId"
          divClass={classes.inputClass}
          value={
            !this.state.formDataCharacteristics.externalId
              ? " "
              : (this.state.formDataCharacteristics.externalId ?? "")
          }
          disabled={this.state.actionType === "view"}
          onChange={this.handleChangeCharacteristics}
        />
      </Grid>
    );
  };

  getCharacteristicTypeList = () => {
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/passthru/GET_PRODUCT_CHARACTERISTIC_TYPE/endpoint`,
      "",
    )
      .then((res) => {
        if (res.data?.types) {
          this.setState({ productCharacteristicsTypes: res.data.types });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Characteristics type:", err);
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  getProductCategoryList = () => {
    BusApiCall("GET", `${constants.busV4Url}/catalog/allComponentTypes`)
      .then((res) => {
        let data = res.data;
        let cData = JSON.parse(data.jsonResponse);
        const sortedCategoryList = [
          ...cData.mappedTypes
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(({ id, name }) => ({ id, name })),
        ];
        this.setState({ specProductCategoryList: sortedCategoryList });
      })
      .catch((err) => {
        console.error("Error fetching Product Categories:", err);
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  removeFieldsOld = (obj, fieldsToRemove) => {
    if (Array.isArray(obj)) {
      return obj.map((item) => this.removeFields(item, fieldsToRemove));
    } else if (typeof obj === "object" && obj !== null) {
      const newObj = {};
      for (const key in obj) {
        if (!fieldsToRemove.includes(key)) {
          newObj[key] = this.removeFields(obj[key], fieldsToRemove);
        }
      }
      return newObj;
    }
    return obj;
  };

  removeFields = (obj, fieldsToRemove, parentKey = "") => {
    if (Array.isArray(obj)) {
      return obj.map((item) =>
        this.removeFields(item, fieldsToRemove, parentKey),
      );
    } else if (typeof obj === "object" && obj !== null) {
      const newObj = {};
      for (const key in obj) {
        // Check if this is the 'id' key inside a 'category' object
        if (fieldsToRemove.includes(key)) {
          // Keep 'id' only if parent is category or productCategory
          if (
            !(
              key === "id" &&
              (parentKey === "category" || parentKey === "productCategory")
            )
          ) {
            continue; // skip (remove field)
          }
        }
        newObj[key] = this.removeFields(obj[key], fieldsToRemove, key);
      }
      return newObj;
    }
    return obj;
  };

  exportProductSpecs = () => {
    console.log("Calling api to start export product specification");
    this.setState({ showLoading: true });
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productSpecifications?sortBy=name&sortOrder=ASC&includeChars=true${
        this.state.specificationSearchString
          ? "&name=" + this.state.specificationSearchString
          : ""
      }${
        this.state.specificationSearchCategory &&
        this.state.specificationSearchCategory !== "-"
          ? "&category=" + this.state.specificationSearchCategory
          : ""
      }`,
      "",
      "",
    )
      .then((res) => {
        var formattedJson = this.removeFields(res.data, ["id", "specId"]);

        /*let compList = [];
                    for (let item of formattedJson) {
                        let tempComp = {
                            name: item.name.trim(),
                            description: item.description.trim(),
                            productSpecCode: item.productSpecCode,
                            category: item.category,
                            isMandatory: item.isMandatory,
                            visibility: item.visibility,
                            productSpecificationRelationship: item.productSpecificationRelationship ? item.productSpecificationRelationship : []
                        };
                        compList.push(tempComp);
                    }*/

        let josnFile =
          "text/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(formattedJson));
        var link = document.createElement("a");
        link.href = "data:" + josnFile;
        link.download = "productSpecifications.json";
        link.dispatchEvent(new MouseEvent("click"));
        this.setState({ showLoading: false });
        this.props.setErrorMessage(
          this.props.t("SPECIFICATION_EXPORT_START"),
          true,
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ showLoading: false });
      });
  };

  importProductSpecs = (file) => {
    console.log("Calling api to start import product specification");
    this.setState({ showLoading: true });
    let fileReader = new FileReader();
    if (file.length > 1) {
      file = file.splice(file.length - 1, 1);
    }
    fileReader.readAsText(file[0]);
    fileReader.onload = (event) => {
      try {
        const parsedData = JSON.parse(event.target.result);
        this.createImportedProductSpecs(parsedData);
      } catch (error) {
        this.props.setErrorMessage(this.props.t("INVALID_JSON_FILE"), false);
        this.setState({ showLoading: false });
      } finally {
        //this.setState({ showLoading: false });
      }
    };
  };

  onFilesError = (error, file) => {
    console.log("error code " + error.code + ": " + error.message);
    var errorMsg = error.code + ": " + error.message;
    this.props.setErrorMessage(errorMsg, false);
  };

  createImportedProductSpecs = (data) => {
    this.setState({ showLoading: true });
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/IMPORT_PRODUCT_SPECIFICATIONS/endpoint`,
      data,
    )
      .then((res) => {
        if (res.data.code === "500" || res.data.code === "400") {
          this.props.setErrorMessage(res.data.errorMessage, false);
        } else {
          if (res.data.message) {
            this.props.setErrorMessage(res.data.message, true);
          } else {
            this.props.setErrorMessage(
              this.props.t("SPECIFICATION_IMPORT_START"),
              true,
            );
          }
          this.getSpecificationList();
        }
        this.setState({ showLoading: false });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ showLoading: false });
      });
  };

  toggleChildVisibility = () => {
    this.setState((prevState) => ({
      showChild: !prevState.showChild, // Toggle the state
    }));
    if (this.state.showChild) {
      this.state.formData = "";
    }
  };

  BreadcrumbSection = () => {
    const { t } = this.props;
    return (
      <div className={"breadcrumbWrapper"}>
        <div className={"breadcrumbContent"}>
          <Grid container>
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <h3 className={"customBreadcrumb"}>
                <label>
                  <>
                    <u style={{ cursor: "pointer" }} onClick={this.goToProduct}>
                      {t("PRODUCTS")}
                    </u>{" "}
                    <span style={{ margin: "0 8px" }}>{">"}</span>{" "}
                    <b>{t("PRODUCT_SPECIFICATION")}</b>
                  </>
                </label>
              </h3>
            </Grid>
            <Grid
              item
              align="right"
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Button
                onClick={() => this.handleOpenDialogSpecification()}
                style={{ marginBottom: ".5rem" }}
              >
                <span
                  style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                {t("NEW")} {t("PRODUCT_SPECIFICATION")}
              </Button>
              <Button
                className="buttonPrimary"
                onClick={this.goToCharacteristic}
                style={{ marginBottom: ".5rem", marginLeft: ".5rem" }}
              >
                {t("PRODUCT_CHARACTERISTICS")}
              </Button>
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end">
            <Grid
              item
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "0.5rem",
                marginBottom: ".5rem",
              }}
              size={{
                xs: 12,
                md: 6,
              }}
            >
              {this.state.productSpecifications.length > 0 && (
                <Button
                  className={"buttonSecondary"}
                  onClick={this.exportProductSpecs}
                >
                  {t("EXPORT")}
                </Button>
              )}
              {(this.props.permissions.includes("CATALOG_ADMIN_ALL") ||
                this.props.permissions.includes("CATALOG_CREATE") ||
                this.props.permissions.includes("CATALOG_ADMIN")) && (
                <div>
                  <FileUploader
                    className="files-dropzone"
                    onChange={this.importProductSpecs}
                    onError={this.onFilesError}
                    accepts={[".json"]}
                    maxFileSize={10000000}
                    minFileSize={0}
                    clickable={true}
                  >
                    <Button
                      className={"buttonSecondary"}
                      style={{ marginLeft: ".5rem", marginRight: ".5rem" }}
                    >
                      {t("IMPORT")}
                    </Button>
                  </FileUploader>
                </div>
              )}

              <ButtonGroup variant="outlined">
                <span
                  className={`buttonGroup ${!this.state.showSpecificationList ? "selected" : ""}`}
                  onClick={(e) => this.toggleShowSpecificationList("detail")}
                  style={{
                    backgroundColor: !this.state.showSpecificationList
                      ? this.props.tenantData.color
                      : "inherit",
                    color: !this.state.showSpecificationList
                      ? "white"
                      : "inherit",
                    paddingTop: 0,
                    paddingBottom: 0,
                  }}
                >
                  <span style={{ marginRight: ".4rem" }}>
                    {this.props.t("SPEC_TREE_VIEW")}
                  </span>
                  <DetailView />
                </span>
                &nbsp;&nbsp;
                <span
                  className={`buttonGroup ${this.state.showSpecificationList ? "selected" : ""}`}
                  onClick={(e) => this.toggleShowSpecificationList("list")}
                  style={{
                    backgroundColor: this.state.showSpecificationList
                      ? this.props.tenantData.color
                      : "inherit",
                    color: this.state.showSpecificationList
                      ? "white"
                      : "inherit",
                    paddingTop: 0,
                    paddingBottom: 0,
                  }}
                >
                  <span>{this.props.t("LIST_VIEW")}</span>
                  <ListView />
                </span>
              </ButtonGroup>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  };

  SearchSection = () => {
    const { t } = this.props;
    return (
      <>
        <Grid container spacing={1}>
          <Grid
            item
            size={{
              xs: 12,
            }}
          >
            <FormControl
              variant="outlined"
              size="small"
              className={classes.customeSelectLabel}
            >
              <InputLabel
                id="categoryLabel"
                style={{ background: "#fff" }}
                shrink
              >
                {t("CATEGORY")}
              </InputLabel>
              <Select
                size="small"
                variant="outlined"
                name="specificationSearchCategory"
                value={this.state.specificationSearchCategory || ""}
                native
                label="Category"
                labelId="categoryLabel"
                onChange={this.onChangeSpecSearchCate}
              >
                <option value="-">Select</option>
                {this.state.specCategoryList.map((item) => (
                  <option key={item.id} value={item.id}>
                    {this.decodeHtml(item.name)}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            style={{ display: "flex", flexWrap: "nowrap" }}
            size={{
              xs: 12,
            }}
          >
            {/*<Grid item xs={12} md={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>*/}
            <Input
              size={"small"}
              variant={"outlined"}
              placeholder={t("SEARCH_SPECIFICATION")}
              value={this.state.specificationSearchString || ""}
              name={"specificationSearchString"}
              onChange={this.onChange}
              divClass={classes.inputClass}
              onKeyDown={this.onSearchKeyDown}
            />
            &nbsp;
            <Tooltip title={t("SEARCH")}>
              <IconButton
                className="iconButtonSecondary"
                onClick={this.getSpecificationList}
              >
                <SearchIcon />
              </IconButton>
            </Tooltip>
            &nbsp;
            <Tooltip title={t("CLEAR")}>
              <IconButton
                className="iconButtonSecondary"
                onClick={this.clearSearch}
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
            &nbsp;
            <Tooltip title={t("Advance Filters")}>
              <IconButton
                className="iconButtonSecondary"
                onClick={this.toggleChildVisibility}
              >
                <AdvanceSearchIcon />
              </IconButton>
            </Tooltip>
            &nbsp;
            <Tooltip
              title={
                this.state.allExpanded ? t("COLLAPSE_ALL") : t("EXPAND_ALL")
              }
            >
              <IconButton
                className="iconButtonSecondary"
                onClick={this.handleToggleExpandCollapse}
              >
                <ExpandAll />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        {this.state.showChild && (
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            style={{
              borderTop: this.state.showChild ? ".5px solid lightgrey" : "none",
              marginLeft: 0,
              marginRight: 0,
              width: "100%",
              justifyContent: "flex-end",
              marginTop: "1rem",
              paddingTop: ".5rem",
            }}
          >
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                className={classes.customeSelectLabel}
              >
                <InputLabel id="categoryProductLabel">
                  {t("PRODUCT_CATEGORY")}
                </InputLabel>
                <Select
                  size="small"
                  variant="outlined"
                  name="searchSpecProductCategory"
                  value={this.state.searchSpecProductCategory || ""}
                  native
                  label="Product Category"
                  labelId="categoryProductLabel"
                  onChange={this.onChangeSpecSearchProdCate}
                >
                  <option value="-">Select</option>
                  {this.state.specProductCategoryList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {this.decodeHtml(item.name)}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Input
                size={"small"}
                variant={"outlined"}
                placeholder={t("PRODUCT_SPEC_CODE")}
                value={this.state.searchProductSpecCode || ""}
                name="searchProductSpecCode"
                onChange={this.onChange}
                divClass={classes.inputClass}
                onKeyDown={this.onSearchKeyDown}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                className={classes.customeSelectLabel}
              >
                <InputLabel
                  id="visibilitySearchLabel"
                  style={{ background: "#fff" }}
                  shrink
                >
                  {t("VISIBILITY")}
                </InputLabel>
                <Select
                  size="small"
                  variant="outlined"
                  name="searchVisibility"
                  value={this.state.searchVisibility || ""}
                  native
                  label="Visibility"
                  labelId="visibilitySearchLabel"
                  onChange={this.onChangeSpecSearchProdCate}
                >
                  <option value="-">Select</option>
                  <option value="Commercial">Commercial</option>
                  <option value="Technical">Technical</option>
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                className={classes.customeSelectLabel}
              >
                <InputLabel
                  id="mandatorySearchLabel"
                  style={{ background: "#fff" }}
                  shrink
                >
                  {t("MANDATORY")}
                </InputLabel>
                <Select
                  size="small"
                  variant="outlined"
                  name="searchIsMandatory"
                  value={this.state.searchIsMandatory || ""}
                  native
                  label="Mandatory"
                  labelId="mandatorySearchLabel"
                  onChange={this.onChangeSpecSearchProdCate}
                >
                  <option value="-">Select</option>
                  <option value="true">True</option>
                  <option value="false">False</option>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        )}
      </>
    );
  };

  PaginationSpec = () => {
    const { t } = this.props;
    return (
      <div className="global-custom-pagination">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalCount)}
          </label>
          <label>
            {t("ROWS_PER_PAGE")}:
            <Select
              value={this.state.rowsPerPage}
              onChange={this.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <Pagination
            count={Math.ceil(this.state.totalCount / this.state.rowsPerPage)}
            onChange={this.handleChangePage}
            page={this.state.page}
            showFirstButton
            showLastButton
          />
        </div>
      </div>
    );
  };

  SectionSpecification = () => {
    const { t } = this.props;
    const matchedCategory = this.state.specCategoryList.find(
      (cat) => cat.id === this.state.selectedSpecificationCategory?.id,
    );
    const matchedProductCategory = this.state.specProductCategoryList.find(
      (cat) => cat.id === this.state.selectedSpecificationProductCategory?.id,
    );
    return (
      <>
        {this.state.showSpecEditForm ? (
          <>
            <Grid container spacing={2} style={{ padding: "20px 8px 20px" }}>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("NAME") + " *"}
                  name="name"
                  divClass={classes.inputClass}
                  value={this.state.formDataSpecification.name || ""}
                  onChange={this.handleChangeSpecification}
                  error={this.state.specificationFormErrors.name}
                />
                {this.state.specificationFormErrors.name && (
                  <p className="text-error"
                    style={{ marginTop: "4px" }}
                  >
                    Name is required.
                  </p>
                )}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("PRODUCT_SPEC_CODE") + " *"}
                  name="productSpecCode"
                  divClass={classes.inputClass}
                  value={this.state.formDataSpecification.productSpecCode || ""}
                  onChange={this.handleChangeSpecification}
                  error={this.state.specificationFormErrors.productSpecCode}
                  inputProps={{ maxLength: 20 }}
                  multiline
                />
                {this.state.specificationFormErrors.productSpecCode && (
                  <p className="text-error"
                    style={{ marginTop: "4px" }}
                  >
                    Code is required.
                  </p>
                )}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("DESCRIPTION") + " *"}
                  name="description"
                  divClass={classes.inputClass}
                  value={this.state.formDataSpecification.description || ""}
                  onChange={this.handleChangeSpecification}
                  error={this.state.specificationFormErrors.description}
                  inputProps={{ maxLength: 255 }}
                  multiline
                />
                {this.state.specificationFormErrors.description && (
                  <p className="text-error"
                    style={{ marginTop: "4px" }}
                  >
                    Description is required.
                  </p>
                )}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="visibilityLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("VISIBILITY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="visibility"
                    value={this.state.formDataSpecification.visibility ?? ""}
                    native
                    label="Visibility"
                    labelId="visibilityLabel"
                    onChange={this.handleChangeSpecification}
                  >
                    <option value="-">Select</option>
                    <option value="Commercial">Commercial</option>
                    <option value="Technical">Technical</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="categoryLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("CATEGORY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="category"
                    value={this.state.formDataSpecification.category?.id ?? ""}
                    native
                    label="Category"
                    labelId="categoryLabel"
                    onChange={this.handleChangeSpecification}
                  >
                    <option value="-">Select</option>
                    {this.state.specCategoryList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {this.decodeHtml(item.name)}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="mandatoryLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("MANDATORY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="isMandatory"
                    value={
                      this.state.formDataSpecification.isMandatory ?? false
                    }
                    native
                    label="Mandatory"
                    labelId="mandatoryLabel"
                    onChange={this.handleChangeSpecification}
                  >
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="productCategoryLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("PRODUCT_CATEGORY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="productCategory"
                    value={
                      this.state.formDataSpecification.productCategory?.id ?? ""
                    }
                    native
                    label="Product Category"
                    labelId="productCategoryLabel"
                    onChange={this.handleChangeSpecification}
                  >
                    <option value="-">Select</option>
                    {this.state.specProductCategoryList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {this.decodeHtml(item.name)}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                align="right"
                size={{
                  xs: 12,
                }}
              >
                <Button
                  onClick={this.toggleSpecInfoForm}
                  style={{ marginRight: "10px" }}
                  className="button buttonSecondary"
                >
                  {t("CANCEL")}
                </Button>
                <Button
                  variant="contained"
                  className="button"
                  onClick={this.handleSubmitSpecification}
                >
                  {t("UPDATE")}
                </Button>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Grid
              item
              size={{
                xs: 12,
                md: 3,
              }}
            >
              <b>{t("NAME")}</b>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 9,
              }}
            >
              {this.state.selectedSpecificationName}
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 3,
              }}
            >
              <b>{t("PRODUCT_SPEC_CODE")}</b>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 9,
              }}
            >
              {this.state.selectedProductSpecCode}
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 3,
              }}
            >
              <b>{t("DESCRIPTION")}</b>
            </Grid>
            <Grid
              item
              style={{ wordBreak: "break-all" }}
              size={{
                xs: 12,
                md: 9,
              }}
            >
              {this.state.selectedSpecificationDescription}
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 3,
              }}
            >
              <b>{t("VISIBILITY")}</b>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 9,
              }}
            >
              {this.state.selectedSpecificationVisibility}
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 3,
              }}
            >
              <b>{t("MANDATORY")}</b>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 9,
              }}
            >
              {String(this.state.selectedSpecificationIsMandatory)}
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 3,
              }}
            >
              <b>{t("CATEGORY")}</b>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 9,
              }}
            >
              {matchedCategory
                ? matchedCategory.name
                : this.state.selectedSpecificationCategory?.name}
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 3,
              }}
            >
              <b>{t("PRODUCT_CATEGORY")}</b>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 9,
              }}
            >
              {matchedProductCategory
                ? matchedProductCategory.name
                : this.state.selectedSpecificationProductCategory?.name}
            </Grid>
          </>
        )}
      </>
    );
  };

  TableSectionCharacteristic = () => {
    const { t } = this.props;
    return (
      <TableContainer>
        <Table
          className={`${classes.table} newGlobalTable`}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "25%" }}>
                <b>{t("NAME")}</b>
              </TableCell>
              <TableCell style={{ width: "25%", wordBreak: "break-all" }}>
                <b>{t("DESCRIPTION")}</b>
              </TableCell>
              <TableCell style={{ width: "15%" }}>
                <b>
                  {t("VALUE")} {t("TYPE")}
                </b>
              </TableCell>
              <TableCell style={{ width: "15%" }}>
                <b>{t("VALUE")}</b>
              </TableCell>
              {/*<TableCell>
                                <b>{t('PRODUCT_SPECIFICATION')} {t('ID')}</b>
                            </TableCell>*/}
              <TableCell style={{ paddingLeft: "1rem" }}>
                {/*<b>&nbsp;{t('REMOVE')}</b>*/}
                <b>&nbsp;{t("ACTION")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.productCharacteristics.map((row, index) => (
              <TableRow key={row.id || `row-${index}`}>
                <TableCell>{row.name}</TableCell>
                <TableCell style={{ wordBreak: "break-all" }}>
                  {row.description}
                </TableCell>
                <TableCell>
                  <span style={{ textTransform: "capitalize" }}>
                    {row?.valueType?.toUpperCase() === "ENUMERATION" ||
                    row?.valueType?.toUpperCase() === "ENUM"
                      ? "Enum"
                      : row?.valueType?.toLowerCase()}
                  </span>
                </TableCell>
                <TableCell>
                  {(row?.valueType?.toUpperCase() === "ENUMERATION" ||
                    row?.valueType?.toUpperCase() === "ENUM") &&
                  Array.isArray(row.characteristicValueSpecification)
                    ? (() => {
                        const defaultItem =
                          row.characteristicValueSpecification.find(
                            (item) => item.isDefault,
                          );
                        return defaultItem
                          ? `${defaultItem.id || ""} : ${defaultItem.value}`
                          : "";
                      })()
                    : row.value}
                </TableCell>
                <TableCell>
                  <div style={{ display: "flex", gap: ".5rem" }}>
                    {!(
                      this.state.selectedSpecificationVisibility ===
                        "Technical" || row.overrideBehavior === "ViewOnly"
                    ) && (
                      <Tooltip title={t("Edit")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={() =>
                            this.handleOpenDialogCharacteristics(row, "edit")
                          }
                          style={{ marginBottom: ".5rem", marginLeft: ".5rem" }}
                        >
                          <EditIconNew />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title={t("View")}>
                      <IconButton
                        className="iconButtonSecondary"
                        onClick={() =>
                          this.handleOpenDialogCharacteristics(row, "view")
                        }
                        style={{ marginBottom: ".5rem", marginLeft: ".5rem" }}
                      >
                        <ViewIconNew />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={t("Delete")}>
                      <IconButton
                        className="iconButtonSecondary"
                        onClick={() => this.deleteCharacteristics(row)}
                        style={{ marginBottom: ".5rem", marginLeft: ".5rem" }}
                      >
                        <DeleteIconNew />
                      </IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
              </TableRow>
            ))}
            {/*this.state.showLoading && (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    {t('LOADING')}
                                </TableCell>
                            </TableRow>
                        )*/}
            {!this.state.showLoading &&
              this.state.productCharacteristics.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {t("NO_CHARACTERISTIC_FOUND")}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  TableSectionAddCharacteristic = () => {
    const { t } = this.props;
    return (
      <TableContainer>
        <Table
          className={`${classes.table} newGlobalTable`}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "20%" }}>
                <b>{t("NAME")}</b>
              </TableCell>
              <TableCell style={{ width: "20%" }}>
                <b>{t("DESCRIPTION")}</b>
              </TableCell>
              <TableCell style={{ width: "15%" }}>
                <b>
                  {t("VALUE")} {t("TYPE")}
                </b>
              </TableCell>
              <TableCell style={{ width: "15%" }}>
                <b>
                  {t("DEFAULT")} {t("VALUE")}
                </b>
              </TableCell>
              <TableCell style={{ width: "20%" }}>
                <b>{t("CATEGORY")}</b>
              </TableCell>
              {/*<TableCell style={{width:'15%'}}>
                                <b>{t('OVERRIDE_BEHAVIOR')}</b>
                            </TableCell>*/}
              <TableCell style={{ width: "10%" }}>
                <b>{t("ADD")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.allProductCharacteristics.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell style={{ wordBreak: "break-all" }}>
                  {row.description}
                </TableCell>
                <TableCell>
                  <span style={{ textTransform: "capitalize" }}>
                    {row?.valueType?.toUpperCase() === "ENUMERATION" ||
                    row?.valueType?.toUpperCase() === "ENUM"
                      ? "Enum"
                      : row?.valueType?.toLowerCase()}
                  </span>
                </TableCell>
                <TableCell>
                  {(row.valueType?.toUpperCase() === "ENUMERATION" ||
                    row?.valueType?.toUpperCase() === "ENUM") &&
                  Array.isArray(row.characteristicValueSpecification)
                    ? (() => {
                        const defaultItem =
                          row.characteristicValueSpecification.find(
                            (item) => item.isDefault,
                          );
                        return defaultItem
                          ? `${defaultItem.id || ""} : ${defaultItem.value}`
                          : "";
                      })()
                    : row.value}
                </TableCell>
                <TableCell>
                  {(() => {
                    const matchedCategory = this.state.charCategoryList.find(
                      (cat) => cat.id === row.category.id,
                    );
                    return matchedCategory
                      ? matchedCategory.name
                      : row.category.name;
                  })()}
                </TableCell>
                {/*<TableCell>
                                    <FormControl
                                        variant="outlined"
                                        size="small"
                                        className={classes.customeSelectLabel}
                                    >
                                        <Select
                                            variant="outlined"
                                            name="overrideBehavior"
                                            value={this.state.overrideBehavior}
                                            native
                                            onChange={(e) => this.onChangeOverrideBehavior(e.target.value, row.id)}
                                        >
                                            <option value="-">Select</option>
                                            {this.state.overrideOptions.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                  {option.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </TableCell>*/}
                <TableCell>
                  <Tooltip title={`${t("SELECT")} ${row.name}`}>
                    <Checkbox
                      color="primary"
                      name={row.id}
                      onChange={(e) => this.handleCheckboxChange(e, row.id)}
                    />
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
            {/*this.state.showLoading && (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    {t('LOADING')}
                                </TableCell>
                            </TableRow>
                        )*/}
            {!this.state.showLoading &&
              this.state.allProductCharacteristics.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {t("NO_CHARACTERISTIC_FOUND")}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  PaginationAllCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className="global-custom-pagination"
        style={{ background: "rgba(196, 196, 196, 0.2)" }}
      >
        <label style={{ float: "left", padding: "5px" }}>
          {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalAllCharacteristicsCount)}
        </label>
        <label>
          {t("ROWS_PER_PAGE")}:
          <Select
            value={this.state.rowsPerPageAllCharacteristics}
            onChange={this.handleChangeRowsPerPageAllCharacteristics}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </label>
        <Pagination
          count={Math.ceil(
            this.state.totalAllCharacteristicsCount /
              this.state.rowsPerPageAllCharacteristics,
          )}
          onChange={this.handleChangePageAllCharacteristics}
          page={this.state.pageAllCharacteristics}
          showFirstButton
          showLastButton
        />
      </div>
    );
  };

  PaginationCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className="global-custom-pagination"
        style={{ background: "rgba(196, 196, 196, 0.2)" }}
      >
        <label style={{ float: "left", padding: "5px" }}>
          {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalCharacteristicsCount)}
        </label>
        <label>
          {t("ROWS_PER_PAGE")}:
          <Select
            value={this.state.rowsPerPageCharacteristics}
            onChange={this.handleChangeRowsPerPageCharacteristics}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </label>
        <Pagination
          count={Math.ceil(
            this.state.totalCharacteristicsCount /
              this.state.rowsPerPageCharacteristics,
          )}
          onChange={this.handleChangePageCharacteristics}
          page={this.state.pageCharacteristics}
          showFirstButton
          showLastButton
        />
      </div>
    );
  };

  SearchSectionCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className={classes.searchOuterDiv}
        style={{ padding: "1rem 0.5rem 0.5rem" }}
      >
        <Grid container spacing={1} justifyContent="flex-end">
          <Grid
            item
            size={{
              xs: 12,
              md: 3,
              sm: 6,
            }}
          >
            <Input
              size={"small"}
              variant={"outlined"}
              placeholder={t("NAME")}
              value={this.state.name}
              name={"name"}
              onChange={this.onChange}
              divClass={classes.inputClass}
              onKeyDown={this.onCharacteristicSearchKeyDown}
            />
          </Grid>
          <Grid
            item
            size={{
              xs: 12,
              md: 4,
              sm: 6,
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Input
                size={"small"}
                variant={"outlined"}
                placeholder={t("DESCRIPTION")}
                value={this.state.characteristicDescription}
                name={"characteristicDescription"}
                onChange={this.onChange}
                divClass={classes.inputClass}
                onKeyDown={this.onCharacteristicSearchKeyDown}
                style={{ paddingRight: ".5rem" }}
              />
              <Tooltip title={t("SEARCH")}>
                <IconButton
                  className="iconButtonSecondary"
                  onClick={this.getCharacteristicList}
                >
                  <SearchIcon />
                </IconButton>
              </Tooltip>
              &nbsp;
              <Tooltip title={t("CLEAR")}>
                <IconButton
                  className="iconButtonSecondary"
                  onClick={this.clearSearchCharacteristic}
                >
                  <ClearIcon />
                </IconButton>
              </Tooltip>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  SearchSectionAllCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className={classes.searchOuterDiv}
        style={{ padding: "1rem 0.5rem 0.5rem" }}
      >
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("NAME")}
            value={this.state.addCharacteristicName || ""}
            name={"addCharacteristicName"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onAllCharacteristicSearchKeyDown}
          />
        </div>
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("DESCRIPTION")}
            value={this.state.addCharacteristicDescription || ""}
            name={"addCharacteristicDescription"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onAllCharacteristicSearchKeyDown}
          />
        </div>
        <div className={classes.searchInputDiv}>
          <FormControl
            variant="outlined"
            size="small"
            className={classes.customeSelectLabel}
          >
            <InputLabel id="categoryLabelSearch" shrink>
              Category
            </InputLabel>
            <Select
              size="small"
              variant="outlined"
              name="searchCategory"
              value={this.state.searchCategory ?? "-"}
              native
              label="Category"
              labelId="categoryLabelSearch"
              onChange={this.onChangeSearchCategory}
            >
              <option value="-">Select</option>
              {this.state.charCategoryList.map((item) => (
                <option key={item.id} value={item.id}>
                  {this.decodeHtml(item.name)}
                </option>
              ))}
            </Select>
          </FormControl>
        </div>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <Tooltip title={t("SEARCH")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.getAllCharacteristicList}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
          &nbsp;
          <Tooltip title={t("CLEAR")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.clearSearchAllCharacteristic}
            >
              <ClearIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  };

  SearchSectionAllSpecification = () => {
    const { t } = this.props;
    return (
      <div
        className={classes.searchOuterDiv}
        style={{ padding: "1rem 0.5rem 0.5rem" }}
      >
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("NAME")}
            value={this.state.addChildSpecName || ""}
            name={"addChildSpecName"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onAllSpecSearchKeyDown}
          />
        </div>
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("DESCRIPTION")}
            value={this.state.addChildSpecDescription || ""}
            name={"addChildSpecDescription"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onAllSpecSearchKeyDown}
          />
        </div>
        <div>
          <FormControl
            variant="outlined"
            size="small"
            className={classes.customeSelectLabel}
          >
            <InputLabel
              id="categoryLabel"
              style={{ background: "#fff" }}
              shrink
            >
              {t("CATEGORY")}
            </InputLabel>
            <Select
              size="small"
              variant="outlined"
              name="addChildSpecCategory"
              value={this.state.addChildSpecCategory}
              native
              label="Category"
              labelId="categoryLabel"
              onKeyDown={this.onAllSpecSearchKeyDown}
              onChange={this.onChangeSpecSearchCate}
            >
              <option value="-">Select</option>
              {this.state.specCategoryList.map((item) => (
                <option key={item.id} value={item.id}>
                  {this.decodeHtml(item.name)}
                </option>
              ))}
            </Select>
          </FormControl>
        </div>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <Tooltip title={t("SEARCH")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.getAllSpecificationList}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
          &nbsp;
          <Tooltip title={t("CLEAR")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.clearSearchAllSpec}
            >
              <ClearIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  };

  PaginationAllSpecification = () => {
    const { t } = this.props;
    return (
      <div
        className="global-custom-pagination"
        style={{ background: "rgba(196, 196, 196, 0.2)" }}
      >
        <label style={{ float: "left", padding: "5px" }}>
          {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalAllSpecificationCount)}
        </label>
        <label>
          {t("ROWS_PER_PAGE")}:
          <Select
            value={this.state.rowsPerPageAllSpec}
            onChange={this.handleChangeRowsPerPageAllSpec}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </label>
        <Pagination
          count={Math.ceil(
            this.state.totalAllSpecificationCount /
              this.state.rowsPerPageAllSpec,
          )}
          onChange={this.handleChangePageAllSpec}
          page={this.state.pageAllSpec}
          showFirstButton
          showLastButton
        />
      </div>
    );
  };

  TableSectionAddChildSpecification = () => {
    const { t } = this.props;
    const matchedCategory = this.state.specCategoryList.find(
      (cat) => cat.id === this.state.selectedSpecificationCategory?.id,
    );
    return (
      <TableContainer>
        <Table
          className={`${classes.table} newGlobalTable`}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "25%" }}>
                <b>{t("NAME")}</b>
              </TableCell>
              <TableCell style={{ width: "20%" }}>
                <b>{t("PRODUCT_SPEC_CODE")}</b>
              </TableCell>
              <TableCell style={{ width: "25%" }}>
                <b>{t("DESCRIPTION")}</b>
              </TableCell>
              <TableCell style={{ width: "20%" }}>
                <b>{t("CATEGORY")}</b>
              </TableCell>
              <TableCell style={{ width: "10%" }}>
                <b>{t("ADD")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.allProductSpecifications.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.productSpecCode}</TableCell>
                <TableCell style={{ wordBreak: "break-all" }}>
                  {row.description}
                </TableCell>
                <TableCell>
                  {(() => {
                    const matchedCategory = this.state.specCategoryList.find(
                      (cat) => cat.id === row.category?.id,
                    );
                    return matchedCategory
                      ? matchedCategory.name
                      : row.category?.name;
                  })()}
                </TableCell>
                <TableCell>
                  <Tooltip title={`${t("SELECT")} ${row.name}`}>
                    <Checkbox
                      color="primary"
                      name={row.id}
                      onChange={(e) =>
                        this.handleChildSpecCheckboxChange(e, row.id)
                      }
                    />
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
            {!this.state.showLoading &&
              this.state.allProductSpecifications.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {t("NO_SPECIFICATION_FOUND")}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  handleChangeRowsPerPageAllSpec = (event) => {
    this.setState(
      {
        pageAllSpec: 1,
        rowsPerPageAllSpec: event.target.value,
        startRecordAllSpec: 1,
      },
      () => {
        this.getAllSpecificationList();
      },
    );
  };

  handleChangePageAllSpec = (event, newPage) => {
    this.setState(
      {
        pageAllSpec: newPage,
        startRecordAllSpec: this.state.rowsPerPageAllSpec * (newPage - 1) + 1,
      },
      () => {
        this.getAllSpecificationList();
      },
    );
  };

  clearSearchAllSpec = () => {
    this.setState(
      {
        addChildSpecName: "",
        addChildSpecDescription: "",
        addChildSpecCategory: "-",
        pageAllSpec: 1,
        startRecordAllSpec: 1,
      },
      () => {
        this.getAllSpecificationList();
      },
    );
  };

  onAllSpecSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getAllSpecificationList();
    }
  };

  handleChildSpecCheckboxChange = (event, selectedSpecId) => {
    const isChecked = event.target.checked;
    this.setState((prevState) => {
      let updatedSpecifications = [...prevState.selectedChildSpecifications];
      if (isChecked) {
        updatedSpecifications.push({ id: selectedSpecId });
      } else {
        updatedSpecifications = updatedSpecifications.filter(
          (item) => item.id !== selectedSpecId,
        );
      }

      return { selectedChildSpecifications: updatedSpecifications };
    });
  };

  TableSectionChildSpecifications = () => {
    const { t } = this.props;
    return (
      <TableContainer>
        <Table
          className={`${classes.table} newGlobalTable`}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "25%" }}>
                <b>{t("NAME")}</b>
              </TableCell>
              <TableCell style={{ width: "50%" }}>
                <b>{t("DESCRIPTION")}</b>
              </TableCell>
              <TableCell style={{ paddingLeft: "1rem" }} align="center">
                <b>&nbsp;{t("ACTION")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.childSpecifications.length > 0 &&
              this.state.childSpecifications.map((row, index) => (
                <TableRow key={row.id || `row-${index}`}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell style={{ wordBreak: "break-all" }}>
                    {row.description}
                  </TableCell>
                  <TableCell>
                    <div
                      style={{
                        display: "flex",
                        gap: ".5rem",
                        justifyContent: "center",
                      }}
                    >
                      {/*<Tooltip title={t('Edit')}>
                                            <IconButton className="iconButtonSecondary" onClick={() => this.handleOpenDialogCharacteristics(row, 'edit')} style={{ marginBottom: '.5rem', marginLeft: '.5rem'}}>
                                              <EditIconNew />
                                            </IconButton>
                                        </Tooltip>*/}
                      <Tooltip title={t("View")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={() =>
                            this.handleOpenDialogChildSpec(row, "view")
                          }
                          style={{ marginBottom: ".5rem", marginLeft: ".5rem" }}
                        >
                          <ViewIconNew />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={t("Delete")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={() =>
                            this.handleOpenDialogDeleteChildSpec(row)
                          }
                          style={{ marginBottom: ".5rem", marginLeft: ".5rem" }}
                        >
                          <DeleteIconNew />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            {!this.state.showLoading &&
              this.state.childSpecifications.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {t("NO_CHILD_SPEC_AVAILABLE")}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  closeChildSpecDeleteConfirm = (val) => {
    if (val) {
      this.deleteChildSpec();
    } else {
      this.setState({
        showDeleteChildSpecConfirmDialog: false,
      });
    }
  };

  deleteChildSpec = () => {
    const previousSelectedPath = this.state.selectedSpecificationPath;
    /*let rootId = this.state.selectedSpecificationId;
        if(previousSelectedPath !== undefined){
            const ids = previousSelectedPath.split("-");
            rootId = ids[0];
        }*/
    //console.log(rootId,"Delete",this.state.deleteChildSpecId);
    const payload = {
      productSpecificationRelationship: [
        {
          id: this.state.deleteChildSpecId,
          action: "DELETE",
        },
      ],
    };
    this.setState({ showLoading: true });
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/productSpecifications/` +
        this.state.selectedSpecificationId,
      payload,
    )
      .then((res) => {
        this.setState({ showLoading: false });
        //this.closeChildSpecDeleteConfirm(false);
        this.setState({
          selectedChildSpecifications: [],
          selectedSpecificationPath: this.state.selectedSpecificationId,
          showDeleteChildSpecConfirmDialog: false,
        });
        this.getSpecificSpecificationDetail(this.state.selectedSpecificationId);
        this.props.setErrorMessage(
          this.props.t("CHILD_SPECIFICATION_REMOVED_SUCCESSFULLY"),
          true,
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        console.error("Error submitting data:", err);
      });
  };

  render() {
    const { t } = this.props;
    // const CustomTabs = withStyles({
    //     indicator: {
    //         backgroundColor: this.props.tenantData.color,
    //     },
    // })(Tabs);
    const { classes: jssClasses } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <Loader loading={this.state.showLoading} />
        <Loader loading={this.state.showLoadingAddChar} />
        {this.BreadcrumbSection()}
        <main style={{ marginBottom: "0px", paddingTop: "0px" }}>
          {!this.state.showSpecificationList && !this.state.showSpecLoading && (
            <div
              style={{
                borderRadius: "8px",
                border: "1px solid lightgrey",
                background: "white",
                marginBottom: "40px",
              }}
            >
              <Grid container spacing={0}>
                <Grid
                  item
                  style={{
                    borderRight: "1px solid lightgrey",
                    padding: "1rem",
                    minHeight: "500px",
                  }}
                  size={{
                    xs: 12,
                    md: 3,
                  }}
                >
                  {this.SearchSection()}
                  <Divider style={{ marginTop: "1rem" }} />
                  <SimpleTreeView
                    className="specificationNodeRoot specificationNodeRootTreeView"
                    expanded={this.state.expandedNodes}
                  >
                    {this.renderTreeItems(this.state.productSpecifications)}
                    {!this.state.showLoading &&
                      this.state.productSpecifications.length === 0 && (
                        <div
                          style={{ paddingTop: "12px", textAlign: "center" }}
                        >
                          {t("NO_SPECIFICATION_FOUND")}
                        </div>
                      )}
                  </SimpleTreeView>
                  <Divider style={{ marginTop: "1rem" }} />
                  {this.state.totalCount > this.state.rowsPerPage &&
                    this.PaginationSpec()}
                </Grid>
                <Grid
                  item
                  style={{
                    overflow: "hidden",
                    padding: "1rem",
                    minHeight: "500px",
                  }}
                  size={{
                    xs: 12,
                    md: 9,
                  }}
                >
                  <div
                    style={{
                      padding: "0 1rem 0 1rem",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ width: "60%" }}>
                      <h3>{this.state.selectedSpecificationName}</h3>
                    </span>
                    {this.state.tabIndex === 1 &&
                      this.state.selectedSpecificationId && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Button
                            onClick={() =>
                              this.handleOpenDialogAddCharacteristics("")
                            }
                            className={"buttonSecondary"}
                            style={{
                              marginBottom: ".5rem",
                              marginLeft: ".5rem",
                            }}
                          >
                            <span
                              style={{
                                marginRight: ".25rem",
                                verticalAlign: "middle",
                              }}
                            >
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {t("ADD")} {t("PRODUCT_CHARACTERISTIC")}
                          </Button>
                        </div>
                      )}
                  </div>
                  <Grid container spacing={1}>
                    <Grid
                      item
                      style={{ paddingBottom: "1rem", overflow: "auto" }}
                      size={{
                        xs: 12,
                      }}
                    >
                      <Tabs
                        value={this.state.tabIndex}
                        onChange={this.handleTabChange}
                        className="tabUnderLine"
                      >
                        <Tab
                          label={t("GENERAL_INFORMATION")}
                          style={{
                            textTransform: "capitalize",
                            fontSize: "16px",
                            opacity: "1",
                          }}
                        />
                        <Tab
                          label={t("PRODUCT_CHARACTERISTICS")}
                          style={{
                            textTransform: "capitalize",
                            fontSize: "16px",
                            opacity: "1",
                          }}
                        />
                      </Tabs>
                      {/* <Box className="tabUnderLine" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>

                                                <CustomTabs
                                                    indicatorColor="primary"
                                                    textColor="#0E121B"
                                                    scrollButtons="auto"
                                                    onChange={this.handleTabChange}
                                                    value={this.state.tabIndex}
                                                    className="createPackageTabs"
                                                    variant='scrollable'
                                                >
                                                    <Tab value={0} label={t("GENERAL_INFORMATION")} />
                                                    <Tab value={1} label={t("PRODUCT_CHARACTERISTICS")} />
                                                </CustomTabs>
                                            </Box>*/}
                    </Grid>
                    <Box paddingTop={3} />
                  </Grid>
                  <Grid container spacing={0}>
                    <Grid
                      item
                      style={{ padding: "1rem" }}
                      size={{
                        xs: 12,
                      }}
                    >
                      {this.state.tabIndex === 0 &&
                        !this.state.showSpecLoading && (
                          <>
                            <Card
                              variant="outlined"
                              style={{
                                borderRadius: "8px",
                                marginBottom: "20px",
                                padding: "1.5rem",
                              }}
                            >
                              <Grid container spacing={2}>
                                <Grid
                                  item
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  size={{
                                    xs: 8,
                                    md: 4,
                                  }}
                                >
                                  <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                                    {t("INFO")}
                                  </h3>
                                </Grid>
                                {this.state.selectedSpecificationId && (
                                  <Grid
                                    item
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                    size={{
                                      xs: 4,
                                      md: 8,
                                    }}
                                  >
                                    <span style={{ marginLeft: "15px" }}>
                                      <Button
                                        className="buttonSecondary"
                                        onClick={() =>
                                          this.toggleSpecInfoForm()
                                        }
                                      >
                                        <span style={{ marginRight: "8px" }}>
                                          <svg
                                            width="14"
                                            height="13"
                                            viewBox="0 0 13 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </span>
                                        {t("EDIT")}
                                      </Button>
                                    </span>
                                  </Grid>
                                )}
                                <Grid
                                  item
                                  style={{
                                    marginTop: ".5rem",
                                    marginBottom: ".5rem",
                                  }}
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  <Divider variant="middle" />
                                </Grid>
                                {this.SectionSpecification()}
                              </Grid>
                            </Card>
                            <Card
                              variant="outlined"
                              style={{
                                borderRadius: "8px",
                                marginBottom: "20px",
                                padding: "1.5rem",
                              }}
                            >
                              <Grid container spacing={2}>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                                    {t("CHILD_SPECIFICATION")}
                                  </h3>
                                </Grid>
                                <Grid
                                  item
                                  style={{
                                    marginTop: ".5rem",
                                    marginBottom: ".5rem",
                                  }}
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  <Divider variant="middle" />
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  <Card
                                    variant="outlined"
                                    style={{
                                      borderRadius: "8px",
                                      marginBottom: "40px",
                                    }}
                                  >
                                    {this.TableSectionChildSpecifications()}
                                  </Card>
                                </Grid>
                              </Grid>
                            </Card>
                          </>
                        )}
                      {this.state.tabIndex === 1 && !this.state.showLoading && (
                        <Card
                          variant="outlined"
                          style={{ borderRadius: "8px", marginBottom: "40px" }}
                        >
                          {this.state.selectedSpecificationId && (
                            <div className={classes.root}>
                              {this.SearchSectionCharacteristic()}
                              {this.TableSectionCharacteristic()}
                              {this.state.totalCharacteristicsCount >
                                this.state.rowsPerPageCharacteristics &&
                                this.PaginationCharacteristic()}
                            </div>
                          )}
                        </Card>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          )}
          {this.state.showSpecificationList && (
            <ProductSpecificationsListView t={t} />
          )}
        </main>
        <Dialog
          open={this.state.dialogOpenSpecification}
          maxWidth="md"
          fullWidth
          disableScrollLock={true}
          // PaperProps={{ className: jssClasses.resizablePaper }}
          PaperComponent={this.selectSpecificationDialog}
          aria-labelledby="select-specification-dialog"
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              this.handleCloseDialogSpecification();
            }
          }}
        >
          <DialogTitle
            style={{ borderBottom: "1px solid #0000001f", cursor: "move" }}
            id="select-specification-dialog"
          >
            <div style={{ display: "flex" }}>
              <span style={{ display: "inline-flex", width: "95%" }}>
                {t("CREATE_PRODUCT_SPECIFICATION")}
              </span>
              <Tooltip title={t("CLOSE")}>
                <IconButton
                  onTouchStart={(event) =>
                    this.handleCloseDialogSpecification()
                  }
                  onClick={(event) => this.handleCloseDialogSpecification()}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </DialogTitle>
          <DialogContent dividers style={{ padding: "30px" }}>
            <Grid container spacing={2}>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("NAME") + " *"}
                  name="name"
                  divClass={classes.inputClass}
                  value={this.state.createDataSpecification.name || ""}
                  onChange={this.handleChangeCreateSpecification}
                  error={this.state.specificationFormErrors.name}
                />
                {this.state.specificationFormErrors.name && (
                  <p className="text-error"
                    style={{ marginTop: "4px" }}
                  >
                    Name is required.
                  </p>
                )}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("PRODUCT_SPEC_CODE") + " *"}
                  name="productSpecCode"
                  divClass={classes.inputClass}
                  value={
                    this.state.createDataSpecification.productSpecCode || ""
                  }
                  onChange={this.handleChangeCreateSpecification}
                  error={this.state.specificationFormErrors.productSpecCode}
                  inputProps={{ maxLength: 20 }}
                  multiline
                />
                {this.state.specificationFormErrors.productSpecCode && (
                  <p className="text-error"
                    style={{ marginTop: "4px" }}
                  >
                    Code is required.
                  </p>
                )}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("DESCRIPTION") + " *"}
                  name="description"
                  divClass={classes.inputClass}
                  value={this.state.createDataSpecification.description || ""}
                  onChange={this.handleChangeCreateSpecification}
                  error={this.state.specificationFormErrors.description}
                  inputProps={{ maxLength: 255 }}
                  multiline
                />
                {this.state.specificationFormErrors.description && (
                  <p className="text-error"
                    style={{ marginTop: "4px" }}
                  >
                    Description is required.
                  </p>
                )}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="visibilityLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("VISIBILITY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="visibility"
                    value={this.state.createDataSpecification.visibility ?? ""}
                    native
                    label="Visibility"
                    labelId="visibilityLabel"
                    onChange={this.handleChangeCreateSpecification}
                  >
                    <option value="-">Select</option>
                    <option value="Commercial">Commercial</option>
                    <option value="Technical">Technical</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="categoryLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("CATEGORY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="category"
                    value={
                      this.state.createDataSpecification.category?.id ?? ""
                    }
                    native
                    label="Category"
                    labelId="categoryLabel"
                    onChange={this.handleChangeCreateSpecification}
                  >
                    <option value="-">Select</option>
                    {this.state.specCategoryList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {this.decodeHtml(item.name)}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="mandatoryLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("MANDATORY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="isMandatory"
                    value={
                      this.state.createDataSpecification.isMandatory ?? false
                    }
                    native
                    label="Mandatory"
                    labelId="mandatoryLabel"
                    onChange={this.handleChangeCreateSpecification}
                  >
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="productCategoryLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("PRODUCT_CATEGORY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="productCategory"
                    value={
                      this.state.createDataSpecification.productCategory?.id ??
                      ""
                    }
                    native
                    label="Product Category"
                    labelId="productCategoryLabel"
                    onChange={this.handleChangeCreateSpecification}
                  >
                    <option value="-">Select</option>
                    {this.state.specProductCategoryList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {this.decodeHtml(item.name)}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              className="button"
              onClick={this.createSpecification}
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.showDeleteChildSpecConfirmDialog}
          maxWidth="sm"
          fullWidth
          disableScrollLock={true}
          // PaperProps={{ className: jssClasses.resizablePaper }}
          PaperComponent={this.selectDeleteChildSpecDialog}
          aria-labelledby="select-deleteChildSpec-dialog"
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              this.closeChildSpecDeleteConfirm(false);
            }
          }}
        >
          <DialogTitle
            style={{ borderBottom: "1px solid #0000001f", cursor: "move" }}
            id="select-deleteChildSpec-dialog"
          >
            <div style={{ display: "flex" }}>
              <span style={{ display: "inline-flex", width: "95%" }}>
                {t("DELETE")}
              </span>
              <Tooltip title={t("CLOSE")}>
                <IconButton
                  onTouchStart={() => this.closeChildSpecDeleteConfirm(false)}
                  onClick={() => this.closeChildSpecDeleteConfirm(false)}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              {t("DELETE_CHILD_SPEC_MESSAGE")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(event) => this.closeChildSpecDeleteConfirm(false)}
              color="primary"
            >
              {t("NO")}
            </Button>
            <Button
              onClick={(event) => this.closeChildSpecDeleteConfirm(true)}
              color="primary"
            >
              {t("YES")}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.dialogOpenChildSpec}
          maxWidth="md"
          fullWidth
          disableScrollLock={true}
          // PaperProps={{ className: jssClasses.resizablePaper }}
          PaperComponent={this.selectChildSpecDialog}
          aria-labelledby="select-ChildSpec-dialog"
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              this.handleCloseDialogChildSpec();
            }
          }}
        >
          <DialogTitle
            style={{ borderBottom: "1px solid #0000001f", cursor: "move" }}
            id="select-ChildSpec-dialog"
          >
            <div style={{ display: "flex" }}>
              <span style={{ display: "inline-flex", width: "95%" }}>
                View {t("CHILD_SPECIFICATION")}
              </span>
              <Tooltip title={t("CLOSE")}>
                <IconButton
                  onTouchStart={(event) => this.handleCloseDialogChildSpec()}
                  onClick={(event) => this.handleCloseDialogChildSpec()}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </DialogTitle>
          <DialogContent dividers style={{ padding: "30px" }}>
            <Grid container spacing={2}>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("NAME") + " *"}
                  name="name"
                  divClass={classes.inputClass}
                  value={this.state.formDataChildSpec.name || ""}
                  disabled
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("DESCRIPTION") + " *"}
                  name="description"
                  divClass={classes.inputClass}
                  value={this.state.formDataChildSpec.description || ""}
                  disabled
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="visibilityLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("VISIBILITY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="visibility"
                    value={this.state.formDataChildSpec.visibility ?? ""}
                    native
                    label="Visibility"
                    labelId="visibilityLabel"
                    disabled
                  >
                    <option value="-">Select</option>
                    <option value="Commercial">Commercial</option>
                    <option value="Technical">Technical</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="mandatoryLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("MANDATORY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="isMandatory"
                    value={this.state.formDataChildSpec.isMandatory ?? false}
                    native
                    label="Mandatory"
                    labelId="mandatoryLabel"
                    disabled
                  >
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="categoryLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("CATEGORY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="category"
                    value={this.state.formDataChildSpec.category?.id ?? ""}
                    native
                    label="Category"
                    labelId="categoryLabel"
                    disabled
                  >
                    <option value="-">Select</option>
                    {this.state.specCategoryList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {this.decodeHtml(item.name)}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="productCategoryLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    {t("PRODUCT_CATEGORY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="productCategory"
                    value={
                      this.state.formDataChildSpec.productCategory?.id ?? ""
                    }
                    native
                    label="Product Category"
                    labelId="productCategoryLabel"
                    disabled
                  >
                    <option value="-">Select</option>
                    {this.state.specProductCategoryList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {this.decodeHtml(item.name)}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          {/*<DialogActions>
                        <Button variant="contained" className='button'>
                            &nbsp;
                        </Button>
                    </DialogActions>*/}
        </Dialog>
        <Dialog
          open={this.state.dialogOpenAddCharacteristics}
          maxWidth={"md"}
          fullWidth={true}
          disableScrollLock={true}
          // PaperProps={{ className: jssClasses.resizablePaper }}
          PaperComponent={this.selectAddCharacteristicDialog}
          aria-labelledby="select-add-characteristic-dialog"
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              this.handleCloseDialogAddCharacteristics();
            }
          }}
        >
          <DialogTitle
            style={{ borderBottom: "1px solid #0000001f", cursor: "move" }}
            id="select-add-characteristic-dialog"
          >
            <div style={{ display: "flex" }}>
              <span style={{ display: "inline-flex", width: "95%" }}>
                {t("ADD")} {t("PRODUCT_CHARACTERISTICS")}
              </span>
              <Tooltip title={t("CLOSE")}>
                <IconButton
                  onTouchStart={(event) =>
                    this.handleCloseDialogAddCharacteristics()
                  }
                  onClick={(event) =>
                    this.handleCloseDialogAddCharacteristics()
                  }
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </DialogTitle>
          <DialogContent
            dividers
            style={{ padding: "30px", position: "relative" }}
          >
            <Grid container spacing={0}>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <div style={{ marginBottom: ".5rem" }}>
                  {this.SearchSectionAllCharacteristic()}
                </div>
                <Card
                  variant="outlined"
                  style={{ borderRadius: "8px", marginBottom: "40px" }}
                >
                  {this.TableSectionAddCharacteristic()}
                  {this.state.totalAllCharacteristicsCount >
                    this.state.rowsPerPageAllCharacteristics &&
                    this.PaginationAllCharacteristic()}
                </Card>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            {/*<Button onClick={this.handleCloseDialogAddCharacteristics} className='button buttonSecondary'>
                            Cancel
                        </Button>*/}
            <Button
              variant="contained"
              className="button"
              onClick={this.handleSubmitAddCharacteristics}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.dialogOpenAddChildSpecification}
          maxWidth="md"
          fullWidth
          disableScrollLock={true}
          PaperComponent={this.selectAddChildSpecDialog}
          style={{ cursor: "move" }}
          PaperProps={
            {
              // className: jssClasses.resizablePaper
            }
          }
          aria-labelledby="add-child-spec-dialog"
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              this.handleCloseDialogAddChildSpecification();
            }
          }}
        >
          <DialogTitle id="add-child-spec-dialog" style={{ cursor: "move" }}>
            <div style={{ display: "flex" }}>
              <span style={{ display: "inline-flex", width: "95%" }}>
                {t("ADD_CHILD_SPEC")} {t("UNDER")} &nbsp;
                <strong>{this.state.parentSpecNameForChild}</strong>
              </span>
              <Tooltip title={t("CLOSE")}>
                <IconButton
                  onTouchStart={(event) =>
                    this.handleCloseDialogAddChildSpecification()
                  }
                  onClick={(event) =>
                    this.handleCloseDialogAddChildSpecification()
                  }
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </DialogTitle>
          <DialogContent
            dividers
            style={{ padding: "30px", position: "relative" }}
          >
            <Grid container spacing={0}>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <div style={{ marginBottom: ".5rem" }}>
                  {this.SearchSectionAllSpecification()}
                </div>
                <Card
                  variant="outlined"
                  style={{ borderRadius: "8px", marginBottom: "40px" }}
                >
                  {this.TableSectionAddChildSpecification()}
                  {this.state.totalAllSpecificationCount >
                    this.state.rowsPerPageAllSpec &&
                    this.PaginationAllSpecification()}
                </Card>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            {/*<Button onClick={this.handleCloseDialogAddChildSpecification} className='button buttonSecondary'>
                            Cancel
                        </Button>*/}
            <Button
              variant="contained"
              className="button"
              onClick={this.handleSubmitAddChildSpecification}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.dialogOpenCharacteristics}
          maxWidth="md"
          fullWidth
          disableScrollLock={true}
          PaperComponent={this.selectCharacteristicDialog}
          aria-labelledby="select-characteristic-dialog"
          // PaperProps={{ className: jssClasses.resizablePaper }}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              this.handleCloseDialogCharacteristics();
            }
          }}
        >
          {!this.state.formDataCharacteristics.id && (
            <DialogTitle
              style={{ borderBottom: "1px solid #0000001f", cursor: "move" }}
              id="select-characteristic-dialog"
            >
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {this.state.actionType !== "view" ? "Create" : ""}{" "}
                  Characteristic Specification
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={(event) =>
                      this.handleCloseDialogCharacteristics()
                    }
                    onClick={(event) => this.handleCloseDialogCharacteristics()}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
          )}
          {this.state.formDataCharacteristics.id && (
            <DialogTitle
              style={{ borderBottom: "1px solid #0000001f", cursor: "move" }}
              id="select-characteristic-dialog"
            >
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {this.state.actionType !== "view" ? "Update" : "View"}{" "}
                  Characteristic Specification
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={(event) =>
                      this.handleCloseDialogCharacteristics()
                    }
                    onClick={(event) => this.handleCloseDialogCharacteristics()}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
          )}
          <DialogContent
            dividers
            style={{ paddingLeft: "30px", paddingRight: "30px" }}
          >
            <Grid container spacing={2}>
              {this.state.formDataCharacteristics.id && (
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <Input
                      name="id"
                      placeholder={t("ID")}
                      variant={"outlined"}
                      divClass={classes.customDiv}
                      size={"small"}
                      style={{ width: "98%" }}
                      value={this.state.formDataCharacteristics.id}
                      onChange={this.handleChangeCharacteristics}
                      disabled={true}
                    />
                  </Grid>
                </Grid>
              )}
              {this.renderCategoryField()}
              {this.renderExternalIdField()}
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder="Name *"
                  name="name"
                  divClass={classes.inputClass}
                  value={this.state.formDataCharacteristics.name ?? ""}
                  disabled={this.state.actionType === "view"}
                  onChange={this.handleChangeCharacteristics}
                  error={this.state.characteristicsFormErrors.name}
                />
                {this.state.characteristicsFormErrors.name && (
                  <p className="text-error"
                    style={{ marginTop: "4px" }}
                  >
                    Name is required.
                  </p>
                )}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder="Description *"
                  name="description"
                  divClass={classes.inputClass}
                  value={this.state.formDataCharacteristics.description ?? ""}
                  disabled={this.state.actionType === "view"}
                  onChange={this.handleChangeCharacteristics}
                  error={this.state.characteristicsFormErrors.description}
                  inputProps={{ maxLength: 255 }}
                  multiline
                />
                {this.state.characteristicsFormErrors.description && (
                  <p className="text-error"
                    style={{ marginTop: "4px" }}
                  >
                    Description is required.
                  </p>
                )}
              </Grid>

              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size={"small"}
                  className={classes.customeSelectLabel}
                  error={!!this.state.characteristicsFormErrors.type}
                >
                  <InputLabel
                    id="characteristicTypeLabel"
                    style={{ background: "#fff" }}
                    shrink
                  >
                    Value Type *
                  </InputLabel>
                  <Select
                    size={"small"}
                    variant={"outlined"}
                    name="valueType"
                    value={this.state.formDataCharacteristics.valueType?.toUpperCase()}
                    native
                    label="Type *"
                    labelId="characteristicTypeLabel"
                    disabled={this.state.actionType === "view"}
                    onChange={this.handleChangeCharacteristics}
                  >
                    <option value="-">Select</option>
                    {this.state.productCharacteristicsTypes
                      .filter(
                        (option) =>
                          option.typeId !== "PRD_CHARS" &&
                          option.typeId !== "OBJECT",
                      )
                      .map((option) => {
                        // Normalize ENUM / ENUMERATION to one value for UI
                        const normalizedTypeId =
                          option.typeId?.toUpperCase() === "ENUMERATION"
                            ? "ENUM"
                            : option.typeId?.toUpperCase();

                        return (
                          <option key={option.typeId} value={normalizedTypeId}>
                            {option.name}
                          </option>
                        );
                      })}
                  </Select>
                  {this.state.characteristicsFormErrors.valueType && (
                    <p className="text-error"
                      style={{
                        marginTop: "4px"
                      }}
                    >
                      Please select a valid characteristic valueType.
                    </p>
                  )}
                </FormControl>
              </Grid>
              {/*this.state.formDataCharacteristics.characteristicId && (
                                <Grid item xs={12} md={6}>&nbsp;</Grid>
                            )*/}
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("VALIDATION_FORMAT")}
                  name="format"
                  divClass={classes.inputClass}
                  value={
                    this.state.actionType === "view" &&
                    !this.state.formDataCharacteristics.format
                      ? " "
                      : (this.state.formDataCharacteristics.format ?? "")
                  }
                  disabled={this.state.actionType === "view"}
                  onChange={this.handleChangeCharacteristics}
                />
              </Grid>

              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                {this.renderInputField()}
              </Grid>
              {this.renderAttributesFields()}

              {this.state.formDataCharacteristics.id &&
                this.state.actionType !== "view" && (
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <p
                      style={{
                        color: "#f44336",
                        position: "absolute",
                        bottom: 0,
                      }}
                    >
                      {t("CHANGE_CHARACTERISTIC_IMPACT")}
                    </p>
                  </Grid>
                )}
            </Grid>
          </DialogContent>
          <Snackbar
            open={!!this.state.responseMessage}
            autoHideDuration={4000}
            onClose={this.handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              severity={this.state.responseSeverity}
              onClose={this.handleCloseSnackbar}
              sx={{ width: "100%" }}
            >
              {this.state.responseMessage}
            </Alert>
          </Snackbar>
          {this.state.actionType !== "view" && (
            <DialogActions>
              {/*<Button onClick={this.handleCloseDialogCharacteristics} className='button buttonSecondary'>
                                Cancel
                            </Button>*/}
              {!this.state.formDataCharacteristics.id && (
                <Button
                  variant="contained"
                  className="button"
                  onClick={this.handleSubmitCharacteristics}
                >
                  Create
                </Button>
              )}
              {this.state.formDataCharacteristics.id && (
                <Button
                  variant="contained"
                  className="button"
                  onClick={this.handleSubmitCharacteristics}
                >
                  Update
                </Button>
              )}
            </DialogActions>
          )}
        </Dialog>
      </div>
    );
  }
}

// const styles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '65vw',
//     },
// };

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    enabledModules: state.auth.enabledModules,
    permissions: state.auth.userPerms,
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(ProductSpecification)));
